import DataGrid, {
  Column,
  ColumnChooser,
  Editing,
  FilterRow,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  RequiredRule,
  Scrolling,
  Selection,
  StateStoring,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import LoadPanel from "devextreme-react/load-panel";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setcontectTableAddDataaa,
  setcontectTableAddDataaa2,
  setgoToDocketPerson,
} from "../../reducer/ParticipateReducer";

import axios from "axios";
import { CheckBox, ContextMenu, Popup, SelectBox } from "devextreme-react";
import { Button } from "devextreme-react/button";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import query from "devextreme/data/query";
import {
  AdminUserListID,
  removeProntactEntitiesdynamicTab,
  set_selected_row,
} from "../../../src/reducer/AdminReadReducer";
import UnActiveIcon from "../../assets/images/close.png";
import ActiveIcon from "../../assets/images/icons/success-check.svg";
import { formatDate, formatDateTime } from "../../pages/Dateapi/dateFormatter";
import { QuickaddObligationPopup } from "../../pages/Participants/ParticipantSubTabs/Dockect/overview/QuickaddObligation";
import { setRecentDocket } from "../../reducer/AddParticipantWizardReducer";
import { removeDynamicTab, set_user_data, setDynamicTab } from "../../reducer/HomePageReducer";
import {
  setAddObligation,
  setdockerValue,
  setgotooblogationValue,
  setresetReportDates,
} from "../../reducer/participantNoteReducer";
import { handleGetLocal } from "../../services/auth-service";
import ThreeDotMenu from "../Common/Icons/ThreeDotMenu";
import { ExportFile } from "../ExportGride/ExportFile";
import { logOut } from "../Logout";
import "./Table.css";
let selected;
let source;
let last;
let reportdatesdata;
let gUserId = localStorage.getItem("gUserId");

const QuickaddObligation = ({
  setgetQuickaddObligationPopup,
  getQuickaddObligationPopup,
  dropdownData,
  docketId,
  toastConfig,
  setToastConfig,
  header,
  callObligationApi,
  setCallObligationApi,
  updateDocketManagement,
}) => {
  const dispatch = useDispatch();
  const { resetReportDates } = useSelector((store) => store.participateNotes);

  return (
    <Popup
      visible={getQuickaddObligationPopup}
      onHiding={() => {
        dispatch(setresetReportDates(!resetReportDates));
        setgetQuickaddObligationPopup(false);
      }}
      showTitle={false}
      width={608}
      height={850}
      showCloseButton={true}
      hideOnOutsideClick={false}
    >
      <QuickaddObligationPopup
        docketId={docketId}
        getQuickaddObligationPopup={getQuickaddObligationPopup}
        setgetQuickaddObligationPopup={setgetQuickaddObligationPopup}
        dropdownData={dropdownData}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        header={header}
        callObligationApi={callObligationApi}
        setCallObligationApi={setCallObligationApi}
        updateDocketManagement={updateDocketManagement}
      />
    </Popup>
  );
};

const Exports = ({ setexportPopupOpen, exportPopupOpen, data, exportwidth, exporttitle, exportFont, allData }) => {
  return (
    <>
      <Popup
        visible={exportPopupOpen}
        onHiding={() => {
          setexportPopupOpen(false);
        }}
        showTitle={false}
        width={500}
        height={300}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <ExportFile
          alldata={data}
          setexportPopupOpen={setexportPopupOpen}
          exportwidth={exportwidth}
          exporttitle={exporttitle}
          exportFont={exportFont}
          allData={allData}
        />
      </Popup>
    </>
  );
};

const getdocument = async (
  id,
  setLoading,
  loading,
  type,
  navigate,
  setFileUrl,
  setFileType,
  setViewerOpen,
  setFileName,
) => {
  setLoading(true);
  const pathname = handleGetLocal("pathURL");
  await axios
    .get(`${process.env.REACT_APP_API_URL}/api/attachments/get-single-attachment?binaryDataId=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        Domain: `${pathname}`,
      },
    })
    .then((val) => {
      setLoading(false);
      const openFileInNewTab = (base64Data, fileName, fileType) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        const url = URL.createObjectURL(blob);

        if (!setViewerOpen) {
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName || "download";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setFileUrl(url);
          setFileType(fileType);
          setFileName && setFileName(fileName);
          setViewerOpen(true);
        }
      };

      const imageData = val?.data?.data?.doc;
      let imageType = type;
      const imageName = val?.data?.data?.fileName;

      openFileInNewTab(imageData, imageName, imageType);
    })
    .catch((val) => {
      setLoading(false);
      if (!val?.response) {
        navigate(`/error/500`);
      } else if (val?.response?.status == 401) {
        logOut();
      }
    });
};

const viewDocument = (rowData, setLoading, loading, navigate, setFileUrl, setFileType, setViewerOpen, setFileName) => {
  const fileName = (rowData?.data?.Filename || "").trim().toLowerCase();
  const category = rowData?.data?.Category;
  const binaryDataId = rowData?.data?.binaryDataId;

  let fileType = "text/plain";

  switch (true) {
    case fileName.endsWith(".pdf"):
      fileType = "application/pdf";
      break;
    case fileName.endsWith(".jpg"):
    case fileName.endsWith(".jpeg"):
      fileType = "image/jpeg";
      break;

    case fileName.endsWith(".png"):
      fileType = "image/png";
      break;

    case fileName.endsWith(".gif"):
      fileType = "image/gif";
      break;

    case fileName.endsWith(".tif"):
    case fileName.endsWith(".tiff"):
      fileType = "image/tiff";
      break;
    case fileName.endsWith(".txt"):
    case fileName.endsWith(".csv"):
      fileType = "text/plain";
      break;
    case fileName.endsWith(".mp3"):
      fileType = "audio/mpeg";
      break;

    case fileName.endsWith(".wav"):
      fileType = "audio/wav";
      break;
    case fileName.endsWith(".mp4"):
      fileType = "video/mp4";
      break;

    case fileName.endsWith(".mov"):
      fileType = "video/quicktime";
      break;
    case fileName.endsWith(".eml"):
      fileType = "message/rfc822";
      break;

    case fileName.endsWith(".msg"):
      fileType = "application/vnd.ms-outlook";
      break;
    case fileName.endsWith(".docx"):
      fileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      break;

    case fileName.endsWith(".doc"):
    case fileName.endsWith(".rtf"):
      fileType = "application/msword";
      break;
    case fileName.endsWith(".json"):
      fileType = "application/json";
      break;
    case fileName.endsWith(".xlsx"):
      fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      break;

    case fileName.endsWith(".xls"):
      fileType = "application/vnd.ms-excel";
      break;
    case category === "Photo":
      fileType = "image/jpeg";
      break;
    default:
      fileType = "text/plain";
      break;
  }
  getdocument(
    binaryDataId,
    setLoading,
    loading,
    fileType,
    navigate,
    setFileUrl,
    setFileType,
    setViewerOpen,
    setFileName,
  );
};

export const Table2 = forwardRef(
  (
    {
      filterValues,
      setFilterValues,
      dockerHeaderData,
      Tablecoloum,
      tableRow,
      handleSplitRow,
      load,
      coloumWidthText,
      setPerson,
      approveTaskProcessCloseout,
      AllocationAdjustment,
      editTable,
      newrowData,
      tabledata,
      setShowPersonModal,
      mandatoryColoum,
      setpopUp,
      wordWrapEnabled,
      setIsPopupVisible,
      contactInfoType,
      editParticipant,
      showTotalBlock,
      recivePayment,
      setNoteEditTable,
      setaddDataIngTable,
      setGetEditData,
      resetvalueonedit,
      Contextmenu,
      setenterAttendencePopup,
      setreportDataId,
      setvoidPopup,
      setLast,
      setremoveAttendenceStatus,
      removeAttendenceStatus,
      setPostReportNote,
      editableperticularValue,
      exportInDifferentFormate,
      exportPopupOpen,
      setexportPopupOpen,
      exportwidth,
      exporttitle,
      exportFont,
      getAttachmenteditData,
      seteditAttachmentPopupOpen,
      attachmentRightCickPopup,
      setattachmentdeletePopup,
      DocketObligationTableSum,
      setgetbinaryDataIdInAttachment,
      DocketObligationTableRightClick,
      setopenGeneratePaymentPlanpopup,
      setWrieOffpopup,
      setObligationData,
      setgeneratePaymenttogal,
      multiselection,
      Revocationscontextmenu,
      seteditRevocationspopup,
      setgetEDitdataRevocations,
      setVoidPopup,
      taskcontextmenu,
      taskcontextmenu2,
      setAddQuickPopup,
      setresettask,
      resettask,
      setgettaskEditDAta,
      gettaskEditDAta,
      setPendingPOpuptogal,
      getCompletTask,
      setVoideFalse,
      doToDocketFind,
      setDocketFind,
      CheckListTableRightClick,
      seteditCHeckoutNotePOpup,
      setgetCheckLIstActivity,
      nojump,
      checklistgetTopDynamicDocketid,
      setresetCHecklist,
      CHecklistreset,
      editCheclListOptionrightClist,
      editchecklistoptionsetpopup,
      seteditdatachecklist,
      GoToChildDocketrightClick,
      goToObligationFinfDocket,
      setGoTOObligationReference,
      setfindDocker,
      goToObligationFinfObligation,
      setfindObligation,
      docketlisthiperline,
      setentitidata,
      entitidata,
      formjump,
      personStatusActiveFilter,
      setConfirmationPopup,
      setConfirmationData,
      REportWizardActiveLIst,
      REportWizardPaymentlist,
      PaymentlistReportWizardTotal,
      ActivitylistReportWizardTotal,
      FindProntactEntities,
      setProntactEntitiesfind,
      ContactPositiondropdown,
      Contactdropdown,
      ProntactEntitiesSubTabContectLIst,
      preview,
      prewviewtogal,
      ActivePersonList,
      DocketLIstreportwizard,
      ObligationLIstReportWizard,
      DisbursementReportWizard,
      ReportDateReportWizard,
      DrugTestREportWizardReportWizard,
      ReportWizardDocketLIstrightclick,
      ActivePersonListrightclick,
      ReportDaterightclick,
      Disbursementrightclick,
      DrugTestREportWizardrightclick,
      ObligationLIstrightclick,
      AllocationAdjustmenttgrid2,
      AllocationAdjustmenttgrid1,
      setupdategrid1,
      setupdategrid2,
      SharequeryTableselectall,
      setgetselectdata,
      sharequeryshow,
      settablereload,
      tablereload,
      coloumchosser,
      PreDisbursementsReport,
      PreDisbursementsReporteightclick,
      DocketManagementRightClick,
      setPrintCheckPopup,
      DocketManagementTotalshow,
      GoToDocketSupervisiontable,
      DocketSupervisionDropdowndata,
      DocketSupervisioncheckdata,
      setdata2deopdown,
      ReportDatestablerowdata,
      Checklist,
      setchecklisteditdata,
      arrearageMinderMenu,
      setArrearageRowData,
      arrearageRowData,
      setSendEmailPopup,
      setAddTaskPopupType,
      setReassignTasksPopup,
      selectedRowCheckbox,
      setSelectedRowCheckbox,
      saveContact,
      setSaveContact,
      setGoodToSaveParticipant,
      updateDocketManagement,
      setCheckedFalse,
      setVisibleRows,
      visibleRows,
      revenueReportMenu,
      revenueRowData,
      setRevenueRowData,
      revenueReportTotal,
      agingReportMenu,
      agingRowData,
      setAgingRowData,
      setChangesuperviserDatePOpup,
      disbursementrowdata,
      setdisbursementrowdata,
      setChangeFinancialStatusPopup,
      obligationDetailTotal,
      reallocatePaymentTotal,
      editableAllocationAmount,
      setAddTollingPopup,
      setChangeSupervisorPopup,
      selectedPersonIds,
      setSelectedPersonIds,
      showSendEmailPopup,
      personListControl,
      periodSummaryControl,
      docketListControl,
      AddParticipant,
      updateTotalAmount,
      setIsMergePopupVisible,
      setSourcePersonId,
      fromOP3,
      fromPersonOverview,
      resetPersonFind,
      approveRefund,
      obligationfeeListMenu,
      obligationFeeListRowData,
      setobligationFeeListRowData,
      setConfirmPopup,
      setMergedPerson,
      fromParticipantHeader,
      actionDropdown,
      handleCellValueChanged,
      editInvoiceTable,
      setEditItemPopup,
      setSelectedItem,
      selectedItem,
      setfindUser,
      goToUserFinfUser,
      setSupervisorChangePopup,
      selectedDocketIds,
      setSelectedDocketIds,
      setSendEmail,
      setCheckedRows,
      setAddRevocationspopup,
      setAddWarrentsPopup,
      enableReportDateTabs,
      sentanceNote,
      EMPeriodcontextmenu,
      setgetEDitdataEmPeriod,
      setEMPriodpopshow,
      setEMPriodeditpopshow,
      setEMPeriodConfirmPopup,
      setSelectedAttachment,
      setRecipientCount,
      setAmountToPay,
      onPageSizeChange,
      onPageIndexChange,
      pageSize,
      totalCount,
      pageIndex,
      serverPaging = false,
      paramValues,
      isTypingPreset,
      selectedProc,
      onFilterChanged,
      filterValue,
      columnMap,
      // isAdmin,
      canDeleteNotes,
      onDeleteRow,
      conditionVerbiageMenu,
      setEditVerbiagePopupOpen,
      setEditVerbiageRowData,
      setEditVerbiageMode,
      OffensesMenu,
      setOffensePopupOpen,
      setOffenseRowData,
      setEditOffenseMode,
      taskStatusDefaultFilter,
      gridMaxHeight,
      setFileUrl,
      setFileType,
      setViewerOpen,
      setFileName,
      adminEditAccess,
      adminDeleteAccess,
      setProcessCloseoutTask,
      setProcessCloseoutOpen,
      processpersoncloseout,
    },
    ref,
  ) => {
    const orders = tableRow;
    // console.log("Orders Data:", orders);

    // const [filterValues, setFilterValues] = useState([true]);
    const dataGrid = useRef(null);
    const saveData = async () => {
      await dataGrid.current.instance().saveEditData();
      if (dataGrid.current.instance().hasEditData()) {
        setSaveContact(false);
      }
    };
    useEffect(() => {
      if (saveContact === true) {
        if (dataGrid?.current?.instance()?.hasEditData()) {
          saveData();
        } else {
          setGoodToSaveParticipant(true);
        }
      }
    }, [saveContact]);

    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(0);

    const customizeDate = (data) => {
      setCount(data.value);
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { contectTableAddData, contectTableAddData2 } = useSelector((store) => store.participate);
    const [tabledataa, settabledataa] = useState([...contectTableAddData]);
    const STORAGE_KEY = `${coloumWidthText}ColumnOrder`;
    const [columns, setColumns] = useState(Tablecoloum);
    const [showFilterRow, setShowFilterRow] = useState(false);
    const [showHeaderFilter, setShowHeaderFilter] = useState(true);
    const [currentFilter, setCurrentFilter] = useState("auto");

    const applyFilterTypes = [
      { key: "auto", name: "Immediately" },
      { key: "onClick", name: "On Button Click" },
    ];
    const loadSavedOrder = () => {
      const savedOrder = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (savedOrder) {
        const reorderedColumns = savedOrder.map((field) => columns.find((col) => col.title === field)).filter(Boolean);
        setColumns(reorderedColumns.length ? reorderedColumns : columns);
      }
    };

    const saveColumnOrder = (newOrder) => {
      const order = newOrder.map((col) => col.title);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(order));
    };

    useEffect(() => {
      if (AddParticipant) {
        dispatch(setcontectTableAddDataaa(tabledataa));
      }
    }, [tabledataa]);

    const [Attendance, setAttendance] = useState("");
    const pathname = handleGetLocal("pathURL");

    const saveCookieCrum = async (perdonId) => {
      await axios
        .post(`${process.env.REACT_APP_API_URL}/api/cookie-crumbs/save-cookie-crumb?recordId=${perdonId}`, null, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        })
        .then(() => {})
        .catch((val) => {});
    };

    const [selectedRow, setselectedRow] = useState(undefined);
    const [desableGeneratePaymetPLan, setdesableGeneratePaymetPLan] = useState(false);
    const [desablewriteoff, setdesablewriteoff] = useState(false);
    const [desableReportData, setdesableReportData] = useState(false);
    const [desableRevocation, setdesableRevocation] = useState(false);

    const [locationappend, setlocationappend] = useState(entitidata ? entitidata : []);

    const [DocketSupervisioncheck, setDocketSupervisioncheck] = useState(
      DocketSupervisioncheckdata?.length ? DocketSupervisioncheckdata : [],
    );

    const [DocketSupervisioncheckclone, setDocketSupervisioncheckclone] = useState([]);

    useEffect(() => {
      if (taskStatusDefaultFilter) {
        const saved = JSON.parse(localStorage.getItem(coloumWidthText));

        // if grid state does not exist yet, create it
        const existingColumns = saved?.columns || [];

        let updatedColumns = existingColumns.map((col) => {
          if (col?.dataField === "Status") {
            return {
              ...col,
              filterValues: ["Active"],
              filterType: "include",
            };
          }
          return col;
        });
        const hasStatus = updatedColumns.some((c) => c?.dataField === "Status");
        console.log("updatedColumns", updatedColumns);
        console.log("hasStatus", hasStatus);
        if (!hasStatus) {
          updatedColumns.push({
            dataField: "Status",
            filterValues: ["Active"],
            filterType: "include",
          });
        }

        const newState = {
          ...(saved || {}),
          columns: updatedColumns,
        };

        localStorage.setItem(coloumWidthText, JSON.stringify(newState));
      }
    }, []);

    useEffect(() => {
      setlocationappend(entitidata ? entitidata : []);
    }, [entitidata]);

    useEffect(() => {
      setDocketSupervisioncheck(DocketSupervisioncheckdata?.length ? DocketSupervisioncheckdata : []);
      setDocketSupervisioncheckclone([]);
    }, [DocketSupervisioncheckdata]);

    useEffect(() => {
      if (setentitidata) {
        setentitidata(locationappend);
      }
    }, [locationappend]);
    useEffect(() => {
      const savedSelections = sessionStorage.getItem("PreDisbursements_SelectedIDs");
      if (savedSelections) {
        const parsed = JSON.parse(savedSelections);
        setPreDisbursementsReportcheckbox(parsed);
      }
    }, []);

    useEffect(() => {
      if (setdata2deopdown) {
        setdata2deopdown([
          ...DocketSupervisioncheckclone,
          ...DocketSupervisioncheck.filter((val) => {
            let temp = true;
            for (let i = 0; i < DocketSupervisioncheckdata?.length; i++) {
              if (DocketSupervisioncheckdata[i]?.ID?.toLowerCase() == val?.ID?.toLowerCase()) {
                temp = false;
              }
            }
            if (temp) {
              return val;
            }
          }),
        ]);
      }
    }, [DocketSupervisioncheck]);

    const printTableData = async (dataGrid) => {
      const dataGridInstance = dataGrid.current.instance();

      const visibleColumns = dataGridInstance.getVisibleColumns();
      const headers = [];

      visibleColumns.forEach((column) => {
        if (column.caption !== "Edit" && column.caption !== "Action") {
          headers.push(column.caption);
        }
      });

      // Fetch all rows from the DataGrid (including all pages)
      const dataSource = dataGridInstance.getDataSource();
      const store = dataSource.store();

      // Load all data from the store (ignoring pagination)
      const allData = await store.load({ skip: 0, take: Infinity });

      // Get only the currently filtered rows from DataGrid
      let appliedFilter = dataGridInstance.getCombinedFilter();

      let filteredRows = allData;
      // Apply filtering manually if filter exists
      if (appliedFilter) {
        filteredRows = query(allData).filter(appliedFilter).toArray();
      }

      if (!filteredRows.length) {
        console.warn("No filtered records found.");
        return;
      }

      const rows = [];

      filteredRows.forEach((row) => {
        const rowData = [];
        visibleColumns.forEach((column) => {
          if (column.dataField !== "Edit" && column.caption !== "Action") {
            if (column.dataField === "DOE") {
              rowData.push(
                new Date(row[column.dataField]).toLocaleString("en-US", {
                  month: "numeric",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }),
              );
            } else {
              rowData.push(row[column.dataField]);
            }
          }
        });
        rows.push(rowData);
      });

      // Open a new window for printing
      const printWindow = window.open("", "", "width=600,height=600");
      printWindow.document.open();
      printWindow.document.write(`
      <html>
      <head>
        <title>Table Data</title>
        <style>
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
          tr:nth-child(even) {
            background-color: #f2f2f2;
          }
        </style>
      </head>
      <body>
        <table>
          <thead>
            <tr>
              ${headers.map((header) => `<th>${header}</th>`).join("")}
            </tr>
          </thead>
          <tbody>
            ${rows
              .map((rowData) => `<tr>${rowData.map((cell) => `<td>${cell ? cell : ""}</td>`).join("")}</tr>`)
              .join("")}
          </tbody>
        </table>
      </body>
      </html>
    `);
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    };

    useEffect(() => {
      setTimeout(() => {
        if (preview && prewviewtogal !== undefined) {
          printTableData(dataGrid);
        }
      }, 100);
    }, [prewviewtogal]);

    useEffect(() => {
      if (setVoideFalse) {
        const coloum = JSON.parse(localStorage.getItem(coloumWidthText))?.columns?.map((val) => {
          if (val?.dataField == "Void") {
            return {
              ...val,
              filterValues: [false],
              filterType: "include",
            };
          } else {
            return val;
          }
        });
        const data = {
          ...JSON.parse(localStorage.getItem(coloumWidthText)),
          columns: coloum,
        };
        localStorage.setItem(coloumWidthText, JSON.stringify(data));
      }
      loadSavedOrder();
    }, []);

    useEffect(() => {
      if (setCheckedFalse) {
        const coloum = JSON.parse(localStorage.getItem(coloumWidthText))?.columns?.map((val) => {
          if (val?.dataField == "Active") {
            return {
              ...val,
              filterValues: [false],
              filterType: "include",
            };
          } else {
            return val;
          }
        });
        const data = {
          ...JSON.parse(localStorage.getItem(coloumWidthText)),
          columns: coloum,
        };
        localStorage.setItem(coloumWidthText, JSON.stringify(data));
      }
    }, []);

    useEffect(() => {
      if (SharequeryTableselectall) {
        setTimeout(() => {
          dataGrid?.current?.instance()?.clearSelection();
        }, 10);
      }
    }, [sharequeryshow]);

    const [gridKey, setGridKey] = useState(1);
    const [selectAll, setselectAll] = useState(false);
    const [selectTaskAll, setselectTaskAll] = useState(false);
    const [taskManagercheckbox, setTaskManagercheckbox] = useState([]);
    const [PreDisbursementsReportcheckbox, setPreDisbursementsReportcheckbox] = useState([]);

    // useEffect(() => {
    //   try {
    //     if (PreDisbursementsReport && tableRow && tableRow.length > 0) {
    //       const selectedRows = tableRow.filter((row) => row?.isSelected || row?.checked);
    //       const count = selectedRows.length;
    //       const total = selectedRows.reduce((sum, row) => sum + (parseFloat(row.Amount) || 0), 0);
    //       if (setRecipientCount) setRecipientCount(count);
    //       if (setAmountToPay) setAmountToPay(total);
    //     }
    //   } catch (err) {
    //     console.error("Error updating recipient count/amount:", err);
    //   }
    // }, [selectAll, selectedRowCheckbox, tableRow]);
    useImperativeHandle(ref, () => ({
      getColumnLayout: () => {
        const grid = dataGrid.current?.instance();
        if (!grid) return null;

        const allColumns = grid.getController("columns").getColumns();

        return allColumns.map((col) => ({
          dataField: col.dataField,
          visible: col.visible,
          visibleIndex: col.visibleIndex,
          width: col.width || null,
        }));
      },

      applyColumnLayout: (layout) => {
        const grid = dataGrid.current?.instance();
        if (!grid || !layout) return;

        layout.forEach((col) => {
          if (col.dataField) {
            grid.columnOption(col.dataField, "visible", col.visible);
            grid.columnOption(col.dataField, "visibleIndex", col.visibleIndex);
            if (col.width) grid.columnOption(col.dataField, "width", col.width);
          }
        });
      },
      handleSelectAll: (selectAll) => {
        const grid = dataGrid.current?.instance();
        if (!grid) return;
        const combinedFilter = grid.getCombinedFilter();
        const filteredRows = combinedFilter ? query(tableRow).filter(combinedFilter).toArray() : tableRow;

        let totalAmount = 0;
        let selectedKeys = [];

        if (selectAll) {
          selectedKeys = filteredRows.map((row, index) => {
            totalAmount += parseFloat(row.Amount) || 0;

            return `${row.gPersonID}_${row.FeeCode || row.FeeName || index}`;
          });
        }
        sessionStorage.setItem("PreDisbursements_SelectedIDs", JSON.stringify(selectedKeys));

        sessionStorage.setItem(
          "PreDisbursements_Totals",
          JSON.stringify({
            count: selectedKeys.length,
            amount: totalAmount,
          }),
        );
        setPreDisbursementsReportcheckbox(selectedKeys);
        if (setRecipientCount) setRecipientCount(selectedKeys.length);
        if (setAmountToPay) setAmountToPay(totalAmount);
      },
    }));

    useEffect(() => {
      if (settablereload) {
        setGridKey((prevGridKey) => prevGridKey + 1);
      }
    }, [tablereload]);

    const [checklistdata, setchecklistdata] = useState([]);
    useEffect(() => {
      if (Checklist) {
        let arr = [];
        tableRow?.map((val) => {
          if (val?.bAllowCheck) {
            arr = [
              ...arr,
              {
                recordId: checklistgetTopDynamicDocketid,
                itemRecordId: val?.gCheckListItemRecordId ? val?.gCheckListItemRecordId : null,
                itemId: val?.gCheckListItemId,
                note: val?.Note ? val?.Note : "",
                complete: val?.["Completed ?"] ? true : false,
              },
            ];
          }
          return val;
        });

        setchecklistdata([...arr]);
      }
    }, [tableRow]);

    useEffect(() => {
      if (setchecklisteditdata) {
        setchecklisteditdata(checklistdata);
      }
    }, [checklistdata]);
    const [getQuickaddObligationPopup, setgetQuickaddObligationPopup] = useState(false);

    const [toastConfig, setToastConfig] = useState({
      isVisible: false,
      type: "",
      message: "",
    });

    const [header, setHeader] = useState({});

    const getDropdownDatas = async () => {
      await axios
        .get(`${process.env.REACT_APP_API_URL}/api/docket/docket-dropdown`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        })
        .then((val) => {
          setDropdownData(val?.data?.data);
        })
        .catch((val) => {
          if (!val?.response) {
            navigate(`/error/500`);
          } else if (val?.response?.status == 401) {
            logOut();
          }
        });
    };

    const [dropdownData, setDropdownData] = useState(null);

    const { AddParticipateUserInfo } = useSelector((store) => store.participate);

    useEffect(() => {
      if (coloumWidthText === "DocketManagementTable") {
        setHeader({
          ...header,
          sPersonNameLastFirst: AddParticipateUserInfo.sLastFirst,
        });
        getDropdownDatas();
      }

      if (personStatusActiveFilter) {
        let location = localStorage.getItem("location") || "";
        const coloum = JSON.parse(localStorage.getItem(coloumWidthText))?.columns?.map((val) => {
          if (val?.dataField === "Person Status") {
            return {
              ...val,
              filterValues: ["Active"],
              filterType: "include",
            };
          } else if (val?.dataField === "Primary Location") {
            return {
              ...val,
              filterValues: [location],
              filterType: "include",
            };
          } else {
            return val;
          }
        });
        const data = {
          ...JSON.parse(localStorage.getItem(coloumWidthText)),
          columns: coloum,
        };
        localStorage.setItem(coloumWidthText, JSON.stringify(data));
      }
    }, []);

    useEffect(() => {
      setColumns(Tablecoloum);
    }, [Tablecoloum]);
    const headerFilterInit = {};

    const [initialConfigLoaded, setInitialConfigLoaded] = useState(false);

    useEffect(() => {
      if (initialConfigLoaded) return;

      const savedSize = Number(localStorage.getItem(`${coloumWidthText}_pageSize`));
      const savedIndex = Number(localStorage.getItem(`${coloumWidthText}_pageIndex`));
      const savedFilters = JSON.parse(localStorage.getItem(`${coloumWidthText}_filters`));
      const savedColumns = JSON.parse(localStorage.getItem(`${coloumWidthText}_columns`));

      // Apply page size & index BEFORE DataGrid loads
      // if (savedSize) onPageSizeChange(savedSize);
      // if (!isNaN(savedIndex)) onPageIndexChange(savedIndex);
      if (savedSize && typeof onPageSizeChange === "function") {
        onPageSizeChange(savedSize);
      }
      if (!isNaN(savedIndex) && typeof onPageIndexChange === "function") {
        onPageIndexChange(savedIndex);
      }

      // Apply saved columns to state BEFORE DataGrid loads
      if (savedColumns?.length > 0) {
        const newCols = [...columns];
        savedColumns.forEach((saved) => {
          const c = newCols.find((x) => x.dataField === saved.dataField);
          if (c) {
            c.visibleIndex = saved.visibleIndex;
            c.width = saved.width;
            c.visible = saved.visible;
          }
        });
        setColumns(newCols);
      }

      // Apply header filters BEFORE render
      // if (savedFilters) {
      //   Object.keys(savedFilters).forEach((field) => {
      //     const f = savedFilters[field];
      //     headerFilterInit[field] = {
      //       filterValues: f.filterValues,
      //       filterType: f.filterType,
      //     };
      //   });
      // }

      setInitialConfigLoaded(true);
    }, []);

    const [docketId, setDocketId] = useState(null);
    console.log("Server Paging = ", serverPaging);

    function extractColumnFilter(filter, columnName) {
      if (!filter) return null;
      if (Array.isArray(filter) && typeof filter[0] === "string") {
        return filter[0] === columnName ? filter : null;
      }
      if (Array.isArray(filter)) {
        for (let part of filter) {
          const result = extractColumnFilter(part, columnName);
          if (result) return result;
        }
      }

      return null;
    }

    const store = useMemo(() => {
      return new CustomStore({
        key: "ID",
        load: async (loadOptions) => {
          console.log("loadOptions", loadOptions.filter);
          if (isTypingPreset) {
            return { data: [], totalCount: 0 };
          }

          if (!selectedProc) return { data: [], totalCount: 0 };

          // HEADER FILTER distinct call
          if (loadOptions.group?.length > 0) {
            const columnName = loadOptions.group[0].selector;
            let singleFilter = null;

            if (Array.isArray(loadOptions.filter)) {
              singleFilter = extractColumnFilter(loadOptions.filter, columnName);
            }

            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/query-runner/distinct`,
              {
                storedProcedure: selectedProc,
                columnName,
                parameters: paramValues,
                //   filter:  loadOptions.filter
                // ? JSON.stringify(loadOptions.filter)
                // : null,
                FilterExpression: singleFilter ? JSON.stringify(singleFilter) : null,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                  Domain: pathname,
                },
              },
            );

            return res.data.map((v) => ({
              key: v ?? "(Blanks)",
              items: null,
            }));
          }

          // NORMAL EXECUTE API
          const page = loadOptions.take ? Math.floor((loadOptions.skip || 0) / loadOptions.take) + 1 : 1;

          const pageSize = loadOptions.take || 50;
          const sort = loadOptions.sort?.[0];
          const layout = ref?.current?.getColumnLayout?.();
          console.log("layout", layout);

          const payload = {
            storedProcedure: selectedProc,
            parameters: paramValues,
            page,
            pageSize,
            sortBy: sort?.selector || null,
            sortDesc: sort?.desc ?? false,
            gridLayout: layout ? JSON.stringify(layout) : null,
            filterExpression: loadOptions.filter ? JSON.stringify(loadOptions.filter) : null,
          };

          const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/query-runner/execute`, payload, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              Domain: pathname,
            },
          });

          const withId = (res.data.rows || []).map((r, index) => ({
            ID: (page - 1) * pageSize + index + 1,
            ...r,
          }));

          return {
            data: withId,
            totalCount: res.data.totalCount,
          };
        },
      });
    }, [selectedProc, paramValues, pageSize, pageIndex, filterValue]);

    const dataSource = useMemo(() => {
      return new DataSource({
        store,
        paginate: true,
        pageSize: 50,
      });
    }, [store]);

    console.log("orders", orders);
    // console.log("serverDataSource", serverDataSource);

    return (
      <div style={{ width: "100%" }}>
        <LoadPanel shadingColor="true" visible={load} delay={10} />
        <LoadPanel shadingColor="true" visible={loading} delay={10} />
        <QuickaddObligation
          setgetQuickaddObligationPopup={setgetQuickaddObligationPopup}
          getQuickaddObligationPopup={getQuickaddObligationPopup}
          dropdownData={dropdownData}
          docketId={docketId}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          header={header}
          updateDocketManagement={updateDocketManagement}
        />
        {exportInDifferentFormate && (
          <Exports
            exportPopupOpen={exportPopupOpen}
            setexportPopupOpen={setexportPopupOpen}
            data={dataGrid}
            exportwidth={exportwidth}
            exporttitle={exporttitle}
            exportFont={exportFont}
            allData={tableRow}
          />
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "10px",
            flexWrap: "wrap",
          }}
        >
          <Button
            icon="column-chooser"
            stylingMode="outlined"
            type="normal"
            onClick={() => dataGrid.current.instance().showColumnChooser()}
          />

          {/* Filter Panel (Now to the right of Column Chooser button) */}
          <div className="Table2Options display-flex-div" style={{ gap: "12px", alignItems: "center" }}>
            <p className="go-to-label-filed" style={{ fontWeight: 600 }}>
              Apply Filter
            </p>

            <SelectBox
              items={applyFilterTypes}
              value={currentFilter}
              onValueChanged={(e) => setCurrentFilter(e.value)}
              valueExpr="key"
              displayExpr="name"
              disabled={!showFilterRow}
              style={{ width: "150px" }}
            />

            <CheckBox text="Filter Row" value={showFilterRow} onValueChanged={(e) => setShowFilterRow(e.value)} />
            <CheckBox
              text="Header Filter"
              value={showHeaderFilter}
              onValueChanged={(e) => setShowHeaderFilter(e.value)}
            />
          </div>
        </div>

        <DataGrid
          wordWrapEnabled={wordWrapEnabled}
          className={showTotalBlock ? "" : "showtotal"}
          id="gridContainer"
          key={gridKey}
          filterValue={filterValue}
          onContextMenuPreparing={(e) => {
            setselectedRow(e.row?.data);
            if (handleSplitRow && e.row?.rowType === "data") {
              e.items = e.items || [];
              e.items.push({
                text: "Split",
                // icon: "copy",
                onItemClick: () => {
                  handleSplitRow(e.row.data);
                },
              });
            }

            if (setreportDataId && editParticipant) {
              setAttendance(e.row?.data?.Attendance);
              setreportDataId(e?.row?.key);
              setPostReportNote(e?.row?.data?.[`Pre-Report Note`]);
              setdesableReportData(e?.row?.data?.Void);
            } else if (attachmentRightCickPopup && setgetbinaryDataIdInAttachment) {
              setgetbinaryDataIdInAttachment(e.row?.data?.binaryDataId);
            } else if (DocketObligationTableRightClick && setObligationData) {
              if (e?.row?.data?.["Balance Owed"] <= 0) {
                setdesableGeneratePaymetPLan(true);
              } else {
                setdesableGeneratePaymetPLan(false);
              }

              if (e?.row?.data?.["Balance Owed"] <= 0) {
                setdesablewriteoff(true);
              } else {
                setdesablewriteoff(false);
              }
              setObligationData(e?.row?.data);
              setgeneratePaymenttogal((prev) => !prev);
            } else if (setgetEDitdataRevocations && Revocationscontextmenu) {
              setgetEDitdataRevocations(e?.row?.data);
              setdesableRevocation(e?.row?.data?.Void);
            } else if (EMPeriodcontextmenu) {
              setgetEDitdataEmPeriod(e?.row?.data);
            } else if (taskcontextmenu && setgettaskEditDAta) {
              setgettaskEditDAta(e?.row?.data);
            } else if (CheckListTableRightClick && setgetCheckLIstActivity) {
              setgetCheckLIstActivity(e?.row?.data);
            } else if (seteditdatachecklist && editCheclListOptionrightClist) {
              seteditdatachecklist(e?.row?.data);
            } else if (ReportDatestablerowdata) {
              ReportDatestablerowdata(e.row?.data);
            } else if (arrearageMinderMenu) {
              setArrearageRowData(e.row?.data);
            } else if (obligationfeeListMenu) {
              setobligationFeeListRowData(e.row?.data);
            } else if (conditionVerbiageMenu) {
              setEditVerbiageRowData(e.row?.data?.obj);
            } else if (OffensesMenu) {
              setOffenseRowData(e.row?.data?.obj);
            } else if (taskcontextmenu2 && setgettaskEditDAta) {
              setgettaskEditDAta(e?.row?.data);
            } else if (revenueReportMenu) {
              setRevenueRowData(e?.row?.data);
            } else if (agingReportMenu) {
              setAgingRowData(e?.row?.data);
            } else if (editInvoiceTable) {
              setSelectedItem(e?.row?.data);
            }
          }}
          ref={dataGrid}
          // dataSource={orders}
          dataSource={serverPaging ? dataSource : orders}
          // remoteOperations={serverPaging ? { paging: true } : false}
          // remoteOperations={serverPaging}
          // remoteOperations={{
          //   paging: true,
          //   sorting: true,
          //   filtering: true, // IMPORTANT: let header filter use CustomStore load()
          //   groupPaging: true,
          // }}
          remoteOperations={
            serverPaging
              ? {
                  paging: true,
                  sorting: true,
                  filtering: true,
                  groupPaging: true,
                }
              : false
          }
          cellHintEnabled={true}
          keyExpr="ID"
          showBorders={true}
          // height={"calc(100vh - 260px)"}
          // style={{ maxHeight: "calc(100vh - 260px)" }}
          style={{
            maxHeight: gridMaxHeight ? gridMaxHeight : "calc(100vh - 260px)",
          }}
          loadPanel={false}
          allowColumnResizing={true}
          columnResizingMode={"nextColumn"}
          rowAlternationEnabled={true}
          onCellPrepared={(e) => {
            if (SharequeryTableselectall) {
            }
            if (e.isAltRow) {
              e.cellElement.style.backgroundColor = "var(--table-second-row-light-black)";
              e.cellElement.style.color = "var(--white-black)";
            }
          }}
          showColumnLines={true}
          showRowLines={true}
          allowColumnReordering={true}
          onContentReady={(e) => {
            e.component.columnOption("command:edit", "visibleIndex", -1);
            if (coloumWidthText === "QueryBuilderTableWidth") {
              e.component.columnOption("ID", "visible", false);
            }
            //          if (filterValue) {
            //     e.component.option("filterValue", filterValue);
            // }
            if (recivePayment) {
              if (visibleRows?.length !== e.component.getVisibleRows().length) {
                setVisibleRows(e.component.getVisibleRows());
              }
            }
          }}
          onRowInserting={(e) => {
            if (tabledata && editParticipant) {
              newrowData({ data: e, name: "insert" });
            }
          }}
          onSaved={(e) => {
            if (AddParticipant) {
              if (e?.changes[0]?.type == "insert") {
                if (ProntactEntitiesSubTabContectLIst) {
                  dispatch(setcontectTableAddDataaa2([...contectTableAddData2, e?.changes[0]?.data]));
                  return;
                } else {
                  settabledataa([...tabledataa, ...e?.changes.map((change) => change?.data)]);
                }
              } else if (e?.changes[0]?.type == "update") {
                if (ProntactEntitiesSubTabContectLIst) {
                  dispatch(
                    setcontectTableAddDataaa2(
                      contectTableAddData2?.map((val) => {
                        if (val.ID === e.changes[0].data.ID) {
                          return e.changes[0].data;
                        } else {
                          return val;
                        }
                      }),
                    ),
                  );
                  return;
                } else {
                  settabledataa(
                    tabledataa.map((val) => {
                      e.changes.forEach((change) => {
                        if (val.ID === change.data.ID) return change.data;
                      });
                      return val;
                    }),
                  );
                }
              }
            }
            if (actionDropdown?.length) {
              handleCellValueChanged();
            }
          }}
          onRowUpdating={(e) => {
            if (recivePayment && editableperticularValue) {
              updateTotalAmount(e?.newData["Amount to Pay"], e?.key);
            }
            if (tabledata && editParticipant) {
              newrowData({ data: e, name: "edit" });
            }
            if (AllocationAdjustmenttgrid1 && setupdategrid1) {
              setupdategrid1(e);
            }
            if (AllocationAdjustmenttgrid1 && setupdategrid2) {
              setupdategrid2(e);
            }
            if (GoToDocketSupervisiontable) {
              setDocketSupervisioncheck(
                DocketSupervisioncheck.map((val) => {
                  if (val?.ID?.toLowerCase() == e?.key?.toLowerCase()) {
                    return { ...val, Type: e?.newData?.Type };
                  } else {
                    return val;
                  }
                }),
              );
            }
          }}
          onRowRemoving={(e) => {
            if (tabledata && editParticipant) {
              newrowData({ data: e, name: "delete" });
            }
            if (!editParticipant) {
              if (ProntactEntitiesSubTabContectLIst) {
                dispatch(
                  setcontectTableAddDataaa2(
                    contectTableAddData2?.filter((val) => {
                      if (val.ID !== e.data.ID) {
                        return val;
                      }
                    }),
                  ),
                );
                return;
              }
              settabledataa(
                tabledataa.filter((val) => {
                  if (val.ID !== e.data.ID) {
                    return val;
                  }
                }),
              );
            }
          }}
          onSelectionChanged={(e) => {
            if (setgetselectdata && SharequeryTableselectall) {
              setgetselectdata(e);
            }
          }}
          onOptionChanged={(e) => {
            if (serverPaging && e.fullName.startsWith("columns") && e.name === "visible") {
              const grid = dataGrid.current?.instance();
              const allCols = grid.getController("columns").getColumns();

              const simplified = allCols.map((col) => ({
                dataField: col.dataField,
                visible: col.visible,
                visibleIndex: col.visibleIndex,
                width: col.width || null,
              }));

              localStorage.setItem(`${coloumWidthText}_columns`, JSON.stringify(simplified));
            }

            if (!initialConfigLoaded) return;
            if (e.fullName === "columns[1].filterValues" && recivePayment) {
              setFilterValues(e.value);
            }
            //  if (!tableRow || tableRow.length === 0) return;

            if (
              serverPaging &&
              (e.fullName?.includes("filterValues") ||
                e.fullName?.includes("filterType") ||
                e.fullName?.includes("selectedFilterOperation"))
            ) {
              const grid = dataGrid.current?.instance();
              const combinedFilter = grid.getCombinedFilter();
              onFilterChanged && onFilterChanged(combinedFilter);
            }

            if (serverPaging && e.fullName?.includes("filterValues") && (e.value === undefined || e.value === null)) {
              const grid = dataGrid.current?.instance();
              grid.clearFilter();

              onFilterChanged && onFilterChanged(null);
            }

            if (e.fullName === "paging.pageSize") {
              if (isTypingPreset) return;
              localStorage.setItem(`${coloumWidthText}_pageSize`, e.value);
              if (typeof onPageSizeChange === "function") onPageSizeChange(e.value);
            }

            // ---- Save Page Index ----
            if (e.fullName === "paging.pageIndex") {
              if (isTypingPreset) return;
              localStorage.setItem(`${coloumWidthText}_pageIndex`, e.value);
              if (typeof onPageIndexChange === "function") onPageIndexChange(e.value);
            }

            // ---- Save Column Order / Width / Visibility ----
            if (e.fullName.includes("visibleIndex")) {
              const visible = e.component.getVisibleColumns();
              const simplified = visible.map((col) => ({
                dataField: col.dataField,
                width: col.width || null,
                visibleIndex: col.visibleIndex,
                visible: col.visible,
              }));

              localStorage.setItem(`${coloumWidthText}_columns`, JSON.stringify(simplified));
            }

            // ---- Save Column Visibility ----
            if (e.fullName.startsWith("columns") && e.name === "visible") {
              const columnField = e.fullName.split(".")[1];
              const updated = columns.map((col) => (col.title === columnField ? { ...col, visible: e.value } : col));
              setColumns(updated);
            }
          }}
          // customizeColumns={(columns) => {
          //   columns.forEach((column, index) => (column.visibleIndex = index));
          // }}
          customizeColumns={(cols) => {
            // 1) Load saved settings
            const saved = JSON.parse(localStorage.getItem(`${coloumWidthText}_columns`));

            if (saved && Array.isArray(saved)) {
              saved.forEach((savedCol) => {
                const col = cols.find((c) => c.dataField === savedCol.dataField);
                if (col) {
                  if (savedCol.visibleIndex !== undefined) col.visibleIndex = savedCol.visibleIndex;

                  if (savedCol.width) col.width = savedCol.width;

                  if (savedCol.visible !== undefined) col.visible = savedCol.visible;
                }
              });

              // Sort columns visually by visibleIndex
              cols.sort((a, b) => (a.visibleIndex ?? 999) - (b.visibleIndex ?? 999));
            }

            // 2) Your fallback logic if no saved order exists
            else {
              cols.forEach((column, index) => {
                column.visibleIndex = index;
              });
            }
          }}
        >
          {/* DataGrid tag end */}
          {/* <FilterRow
          visible={true}
          // applyFilter={currentFilter}
        /> */}
          <FilterRow visible={showFilterRow} applyFilter={currentFilter} />

          <HeaderFilter visible={showHeaderFilter} allowSearch={true} />
          <Scrolling mode="standard" showScrollbar="always" />
          {/* <SearchPanel visible={true} width={240} placeholder="Search..." /> */}

          {multiselection && <Selection mode="multiple" showCheckBoxesMode="always" />}

          {SharequeryTableselectall && <Selection mode="multiple" showCheckBoxesMode="always" />}
          {/* {coloumchosser && <ColumnChooser position={{
          my: "right",
          at: "right",
          of: window,
          offset: "0 0",
        }} enabled={true} allowSearch={true} mode="dragAndDrop" />} */}

          {coloumchosser && <ColumnChooser height="340px" width="400px" enabled={true} mode="dragAndDrop" />}

          {ProntactEntitiesSubTabContectLIst ? (
            <Editing mode="batch" allowAdding={editTable} allowDeleting={false} allowUpdating={editTable} />
          ) : editParticipant ? (
            <Editing mode="batch" allowAdding={editTable} allowDeleting={editTable} allowUpdating={editTable} />
          ) : (
            ""
          )}

          {editableperticularValue && <Editing mode="cell" allowUpdating={true} />}
          {editableAllocationAmount && <Editing mode="cell" allowUpdating={editableAllocationAmount} />}
          {AllocationAdjustmenttgrid1 && <Editing mode="cell" allowUpdating={true} />}
          {GoToDocketSupervisiontable && <Editing mode="cell" allowUpdating={true} allowAdding={false} />}
          {actionDropdown?.length && <Editing mode="cell" allowUpdating={true} allowAdding={false} />}
          <StateStoring savingTimeout={10} enabled={true} type="localStorage" storageKey={coloumWidthText} />
          <Summary>
            <TotalItem column={mandatoryColoum} summaryType="count" customizeText={customizeDate} />
            {processpersoncloseout && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {recivePayment && (
              <TotalItem
                displayFormat="{0}"
                column="Amount Due"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {recivePayment && (
              <TotalItem
                displayFormat="{0}"
                column="Balance Due"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {recivePayment && (
              <TotalItem
                displayFormat="{0}"
                column="Amount Payable"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {recivePayment && (
              <TotalItem
                displayFormat="{0}"
                column="Arrears"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {recivePayment && (
              <TotalItem
                displayFormat="{0}"
                column="Amount to Pay"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Paid"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="On Hand"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Written Off"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && <TotalItem column="Obligation Type" displayFormat="{0}" summaryType="count" />}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Balance Owed"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Disbursed"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketObligationTableSum && (
              <TotalItem
                displayFormat="{0}"
                column="Arrears"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}

            {PaymentlistReportWizardTotal && <TotalItem displayFormat="{0}" column="Offender No" summaryType="count" />}
            {PaymentlistReportWizardTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Allocation Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {PaymentlistReportWizardTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Payment Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ActivitylistReportWizardTotal && <TotalItem displayFormat="{0}" column="Offender #" summaryType="count" />}
            {ActivePersonList && <TotalItem displayFormat="{0}" column="Last Name" summaryType="count" />}
            {DocketLIstreportwizard && <TotalItem displayFormat="{0}" column="Offender" summaryType="count" />}
            {DocketLIstreportwizard && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketLIstreportwizard && (
              <TotalItem
                displayFormat="{0}"
                column="Write Off"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketLIstreportwizard && (
              <TotalItem
                displayFormat="{0}"
                column="Paid"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketLIstreportwizard && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && <TotalItem displayFormat="{0}" column="Offender" summaryType="count" />}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Paid"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Write Off"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="On Hand"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ObligationLIstReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Arrears"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DisbursementReportWizard && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {ReportDateReportWizard && <TotalItem displayFormat="{0}" column="Offender #" summaryType="count" />}
            {DrugTestREportWizardReportWizard && (
              <TotalItem displayFormat="{0}" column="Offender #" summaryType="count" />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="Paid"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="Write Off"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="On Hand"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid1 && (
              <TotalItem
                displayFormat="{0}"
                column="Amount to Deallocate"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {AllocationAdjustmenttgrid2 && (
              <TotalItem
                displayFormat="{0}"
                column="Amount to Allocate"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}

            {PreDisbursementsReport && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {PreDisbursementsReport && (
              <TotalItem
                displayFormat="{0}"
                column="Added Disbursement"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {PreDisbursementsReport && (
              <TotalItem
                displayFormat="{0}"
                column="Sub'd Payment"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {DocketManagementTotalshow && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {revenueReportTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Revenue"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {revenueReportTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Collections"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {obligationDetailTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {reallocatePaymentTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {reallocatePaymentTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {reallocatePaymentTotal && (
              <TotalItem
                displayFormat="{0}"
                column="Allocation Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {actionDropdown?.length && (
              <TotalItem
                displayFormat="{0}"
                column="Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {actionDropdown?.length && (
              <TotalItem
                displayFormat="{0}"
                column="Balance"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
            {actionDropdown?.length && (
              <TotalItem
                displayFormat="{0}"
                column="Adjustment Amount"
                summaryType="sum"
                valueFormat={{ type: "currency", precision: 2 }}
              />
            )}
          </Summary>

          {/* {columns */}
          {columns
            .filter((col) => {
              // hide ID only for Query Builder
              if (coloumWidthText === "QueryBuilderTableWidth" && col.dataField === "ID") {
                return false;
              }
              return true;
            })
            .map((val, i) => {
              // console.log("Rendering column:", val.title);
              if (val?.dropdown) {
                return (
                  <Column dataField={val.title} minWidth={"240"} caption={val.title} width={120}>
                    {/* <Column dataField={val.title} minWidth={"240"} allowHiding={true} visible={val.visible !== false} caption={val.title} width={120}> */}
                    <RequiredRule />
                    <Lookup dataSource={contactInfoType} displayExpr="name" valueExpr={"name"} />
                  </Column>
                );
              } else if (val?.actiondropdown) {
                return (
                  <Column
                    dataField={val.title}
                    minWidth={"240"}
                    caption={val.title}
                    width={120}
                    // <Column dataField={val.title} minWidth={"240"} allowHiding={true} visible={val.visible !== false} caption={val.title} width={120}
                    validationRules={[
                      {
                        type: "custom",
                        validationCallback: (e) => {
                          // Ensure the value is not "-select-" or empty
                          return e.value && e.value !== "-select-";
                        },
                        message: "please enter action",
                      },
                    ]}
                  >
                    <RequiredRule />
                    <Lookup dataSource={actionDropdown} displayExpr="name" valueExpr={"id"} />
                  </Column>
                );
              } else if (val?.dropdown2) {
                return (
                  <Column dataField={val.title} caption={val.title} width={170}>
                    {/* // <Column dataField={val.title} allowHiding={true}  visible={val.visible !== false} caption={val.title} width={170}> */}
                    <RequiredRule />
                    <Lookup dataSource={Contactdropdown} displayExpr="name" valueExpr={"id"} />
                  </Column>
                );
              } else if (val?.dropdown3) {
                return (
                  <Column dataField={val.title} caption={val.title} width={170}>
                    {/* <Column dataField={val.title} allowHiding={true} visible={val.visible !== false}  caption={val.title} width={170}> */}
                    <RequiredRule />
                    <Lookup dataSource={ContactPositiondropdown} displayExpr="name" valueExpr={"id"} />
                  </Column>
                );
              } else if (val?.dropdown4) {
                return (
                  <Column dataField={val.title} caption={val.title} width={170}>
                    {/* <Column dataField={val.title} allowHiding={true} visible={val.visible !== false}  caption={val.title} width={170}> */}
                    <Lookup
                      dataSource={DocketSupervisionDropdowndata?.map((val) => {
                        return { name: val?.value, id: val?.key };
                      })}
                      displayExpr="name"
                      valueExpr={"name"}
                    />
                  </Column>
                );
              } else if (val?.requiredColoumWhileEdit) {
                return (
                  <Column dataField={val.title} caption={val.title} width={170}>
                    {/* <Column dataField={val.title} allowHiding={true} visible={val.visible !== false} caption={val.title} width={170}> */}
                    <RequiredRule />
                  </Column>
                );
              } else if (val?.title == "Active" && recivePayment) {
                return (
                  <Column
                    dataField={val.title}
                    caption={val.title}
                    dataType={"boolean"}
                    width={"auto"}
                    // allowHiding={true}
                    // visible={val.visible !== false}
                    filterValues={filterValues ? [...filterValues] : null}
                    cellRender={(rowData) => {
                      return (
                        <>
                          {rowData?.data?.Active ? (
                            <img src={ActiveIcon} alt={rowData?.data?.Active} />
                          ) : (
                            <img src={UnActiveIcon} alt={rowData?.data?.Active} style={{ height: "18px" }} />
                          )}
                        </>
                      );
                    }}
                  >
                    Active
                  </Column>
                );
              } else if (val?.title === "Alert") {
                return (
                  <Column
                    dataField={val.title}
                    caption={val.title}
                    width={90}
                    alignment="center"
                    cellRender={(cell) => {
                      const data = cell.data;
                      const tooltipText = data?.sPaymentAlert || " ";

                      return (
                        <div title={tooltipText} style={{ cursor: "pointer" }}>
                          <input type="checkbox" checked={data?.Alert ? true : false} readOnly />
                        </div>
                      );
                    }}
                  />
                );
              }
              // else if (val?.title == "Photo") {
              //   return (
              //     <Column
              //       key={val.title}
              //       dataField={val.title}
              //       caption={val.title}
              //       allowSorting={true}
              //       cellRender={<img
              //       src={val.title}
              //       alt="User"
              //       style={{
              //         width: "20px",
              //         height: "20px",
              //         borderRadius: "50%",
              //         objectFit: "cover",
              //       }}
              //     />}
              //     />
              //   );
              // }
              else {
                return (
                  <Column
                    key={val.title}
                    headerFilter={{
                      ...(val.customwidth && { width: val.customwidth }),
                      search: { enabled: true },
                    }}
                    allowEditing={val?.editable ? true : false}
                    // allowHiding={true}
                    // visible={val?.visible !== false}
                    type={
                      val.action || val.Action || val?.viewImage || val?.download || val.moreoption ? "buttons" : ""
                    }
                    width={val.customwidth ? val.customwidth : "auto"}
                    alignment={val?.bool ? "center" : "left"}
                    dataField={val.title}
                    caption={val.title}
                    resizable={true}
                    format={val?.currency && { type: "currency", precision: 2 }}
                    dataType={
                      val?.date
                        ? "date"
                        : val?.number
                          ? "number"
                          : val?.bool
                            ? "boolean"
                            : val?.datetime
                              ? "datetime"
                              : ""
                    }
                    sortOrder={val?.title === "Last Name" && personListControl ? "asc" : ""}
                    cellRender={
                      val?.underLine
                        ? (rowData) => {
                            return (
                              <>
                                <div
                                  style={{
                                    width: "100%",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textDecoration: val?.underLine && "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (FindProntactEntities) {
                                      dispatch(
                                        setDynamicTab({
                                          title: `Entity : ${rowData?.data?.Entity}`,
                                          link: `/prontact/entity/${rowData?.data?.gEntityId}`,
                                          Offender: `/prontact/entity/${rowData?.data?.gEntityId}`,
                                          entityid: rowData?.data?.gEntityId,
                                        }),
                                      );
                                      navigate(`/prontact/entity/${rowData?.data?.gEntityId}`);
                                      dispatch(removeProntactEntitiesdynamicTab(`/prontact/entity`));
                                      setProntactEntitiesfind(false);
                                      return;
                                    }
                                    if (formjump) {
                                      setConfirmationPopup(true);
                                      setConfirmationData(rowData?.data);
                                      return;
                                    }
                                    if (docketlisthiperline) {
                                      dispatch(
                                        setDynamicTab({
                                          Offender: `/docket/${rowData?.data?.gDocketID}`,
                                          link: `/docket/${rowData?.data?.gDocketID}`,
                                          title: `Docket ${rowData?.data?.sDocketNumberCourtCounts}`,
                                          sDocketNumberCourtCounts: rowData?.data?.sDocketNumberCourtCounts,
                                          userinfo: {
                                            ...rowData?.data?.userinfo,
                                            gPersonId: rowData?.data?.userinfo?.gPersonID,
                                          },
                                          getTopDynamicDocketid: rowData?.data?.gDocketID,
                                        }),
                                      );
                                      dispatch(
                                        setdockerValue({
                                          getTopDynamicDocketid: rowData?.data?.gDocketID,
                                          userinfo: {
                                            ...rowData?.data?.userinfo,
                                            gPersonId: rowData?.data?.userinfo?.gPersonID,
                                          },
                                        }),
                                      );
                                      navigate(`/docket/${rowData?.data?.gDocketID}`);
                                      return;
                                    }
                                    if (fromOP3) {
                                      setConfirmationData(rowData?.data);
                                      resetPersonFind();
                                      return;
                                    }

                                    if (fromPersonOverview) {
                                      setConfirmationData(rowData?.data);
                                      resetPersonFind();
                                      return;
                                    }
                                    if (nojump) {
                                      dispatch(
                                        setgoToDocketPerson({
                                          name: rowData?.data?.Name,
                                          id: rowData?.data?.gPersonId,
                                        }),
                                      );
                                      setShowPersonModal && setShowPersonModal(false);
                                      return;
                                    }
                                    if (doToDocketFind) {
                                      dispatch(
                                        setDynamicTab({
                                          Offender: `/docket/${rowData?.data?.gDocketID}`,
                                          link: `/docket/${rowData?.data?.gDocketID}`,
                                          title: `Docket ${rowData?.data?.["Docket #"]}`,
                                          sDocketNumberCourtCounts: rowData?.data?.["Docket #"],
                                          userinfo: rowData?.data,
                                          getTopDynamicDocketid: rowData?.data?.gDocketID,
                                        }),
                                      );

                                      dispatch(
                                        setdockerValue({
                                          getTopDynamicDocketid: rowData?.data?.gDocketID,
                                          userinfo: rowData?.data,
                                        }),
                                      );
                                      setDocketFind(false);

                                      navigate(`/docket/${rowData?.data?.gDocketID}`);

                                      return;
                                    }
                                    if (goToUserFinfUser) {
                                      navigate(`/administration/users/${rowData?.data?.user?.gUserID}`);
                                      dispatch(
                                        setDynamicTab({
                                          title: rowData.data["User ID"],
                                          link: `/administration/users/${rowData.data.user.gUserID}`,
                                        }),
                                      );
                                      dispatch(
                                        AdminUserListID({
                                          userListID: rowData.data.user.gUserID,
                                        }),
                                      );
                                      setfindUser(false);
                                      return;
                                    }
                                    if (goToObligationFinfObligation) {
                                      dispatch(
                                        setDynamicTab({
                                          Offender: `/obligation/${rowData?.data?.gObligationID}/${rowData?.data?.["Obligation Ref #"]}`,
                                          link: `/obligation/${rowData?.data?.gObligationID}/${rowData?.data?.["Obligation Ref #"]}`,
                                          title: `Obligation : ${rowData?.data?.sDocketNumberCourtCounts} / ${rowData?.data?.["Obligation Ref #"]}`,
                                          sDocketNumberCourtCounts: rowData?.data?.sDocketNumberCourtCounts,
                                          ObligationRef: rowData?.data?.["Obligation Ref #"],
                                          gObligationId: rowData?.data?.gObligationID,
                                          userinfo: rowData?.data?.userinfo,
                                        }),
                                      );
                                      dispatch(
                                        setgotooblogationValue({
                                          gObligationId: rowData?.data?.gObligationID,
                                          userinfo: rowData?.data?.userinfo,
                                        }),
                                      );
                                      navigate(
                                        `/obligation/${rowData?.data?.gObligationID}/${rowData?.data?.["Obligation Ref #"]}`,
                                      );

                                      setfindObligation(false);

                                      return;
                                    }
                                    if (goToObligationFinfDocket) {
                                      setGoTOObligationReference({
                                        Reference: rowData.data.Reference,
                                        gDocketID: rowData.data.gDocketID,
                                      });
                                      setfindDocker(false);
                                      return;
                                    }
                                    if (rowData.data.personlistfullName) {
                                      saveCookieCrum(rowData.data.gPersonID);
                                      dispatch(
                                        setDynamicTab({
                                          link: `/participant/${rowData.data["Offender #"]}`,
                                          title: rowData.data.personlistfullName,
                                        }),
                                      );
                                    } else {
                                      saveCookieCrum(rowData.data.gPersonId);
                                      dispatch(
                                        setDynamicTab({
                                          link: `/participant/${rowData.data["Offender #"]}`,
                                          title: rowData?.data?.sLastName,
                                        }),
                                      );
                                    }
                                    if (fromParticipantHeader) {
                                      let currentPath = window.location.href;
                                      const [baseUrl, hashPart] = currentPath.split("#");
                                      dispatch(removeDynamicTab(hashPart));
                                    }
                                    navigate(`/participant/${rowData.data["Offender #"]}`);
                                    setShowPersonModal && setShowPersonModal(false);
                                  }}
                                >
                                  {`${rowData.value}`}
                                </div>
                              </>
                            );
                          }
                        : val?.date
                          ? (rowData) => formatDate(rowData.value)
                          : val?.datetime
                            ? (rowData) => formatDateTime(rowData.value)
                            : val?.action
                              ? (rowData) => {
                                  return (
                                    <>
                                      {adminEditAccess && (
                                        <Button
                                          style={{ marginLeft: "6px", marginTop: "-3px" }}
                                          icon="edit"
                                          onClick={() => {
                                            if (setpopUp) {
                                              setpopUp(1);
                                              setIsPopupVisible(true);
                                              dispatch(
                                                set_selected_row({
                                                  selected_row: rowData.data,
                                                }),
                                              );
                                            }
                                          }}
                                        />
                                      )}
                                      {adminDeleteAccess && (
                                        <Button
                                          style={{ marginLeft: "6px", marginTop: "-3px" }}
                                          icon="trash"
                                          onClick={() => {
                                            if (setpopUp) {
                                              setpopUp(2);
                                              setIsPopupVisible(true);
                                              dispatch(
                                                set_selected_row({
                                                  selected_row: [rowData.data],
                                                }),
                                              );
                                            }
                                          }}
                                        />
                                      )}
                                    </>
                                  );
                                }
                              : val?.Action
                                ? (rowData) => {
                                    console.log("notesdata");
                                    return (
                                      <>
                                        {!rowData.data.bSystem &&
                                          rowData.data.showedit === new Date().toISOString().split("T")[0] &&
                                          rowData.data.gEntryUserId == localStorage.getItem("gUserId") && (
                                            <Button
                                              style={{
                                                marginLeft: "6px",
                                                marginTop: "-3px",
                                              }}
                                              icon="edit"
                                              onClick={() => {
                                                if (setNoteEditTable) {
                                                  setGetEditData(rowData.data);
                                                  setNoteEditTable(true);
                                                  setaddDataIngTable(false);
                                                  resetvalueonedit();
                                                }
                                              }}
                                            />
                                          )}
                                        {canDeleteNotes && (
                                          <Button
                                            style={{ marginLeft: "6px", marginTop: "-3px" }}
                                            icon="trash"
                                            onClick={() => onDeleteRow(rowData.data)}
                                          />
                                        )}
                                        {getAttachmenteditData && seteditAttachmentPopupOpen && (
                                          <Button
                                            style={{
                                              marginLeft: "6px",
                                              marginTop: "-3px",
                                            }}
                                            icon="edit"
                                            onClick={() => {
                                              if (getAttachmenteditData && seteditAttachmentPopupOpen) {
                                                seteditAttachmentPopupOpen(true);
                                                getAttachmenteditData(rowData.data);
                                              }
                                            }}
                                          />
                                        )}
                                      </>
                                    );
                                  }
                                : val?.viewImage
                                  ? (rowData) => {
                                      return (
                                        <>
                                          <Button
                                            style={{
                                              marginLeft: "6px",
                                              marginTop: "-3px",
                                            }}
                                            icon="find"
                                            onClick={() => {
                                              viewDocument(
                                                rowData,
                                                setLoading,
                                                loading,
                                                navigate,
                                                setFileUrl,
                                                setFileType,
                                                setViewerOpen,
                                                setFileName,
                                              );
                                            }}
                                          />
                                        </>
                                      );
                                    }
                                  : val?.download
                                    ? (rowData) => {
                                        return (
                                          <Button
                                            style={{ marginLeft: "6px", marginTop: "-3px" }}
                                            icon="download"
                                            onClick={() => {
                                              const fileName = rowData?.data?.Filename || "file";
                                              const lowerFileName = fileName.toLowerCase();

                                              let fileType = "application/octet-stream";

                                              if (lowerFileName.includes(".pdf")) {
                                                fileType = "application/pdf";
                                              } else if (
                                                lowerFileName.includes(".jpg") ||
                                                lowerFileName.includes(".jpeg")
                                              ) {
                                                fileType = "image/jpeg";
                                              } else if (lowerFileName.includes(".png")) {
                                                fileType = "image/png";
                                              }

                                              getdocument(
                                                rowData?.data?.binaryDataId,
                                                setLoading,
                                                loading,
                                                fileType,
                                                navigate,
                                                null,
                                                null,
                                                null,
                                              );
                                            }}
                                          />
                                        );
                                      }
                                    : val?.warrningIcon
                                      ? (rowData) => {
                                          return (
                                            <>
                                              {!rowData.data["!"] && (
                                                <Button
                                                  style={{
                                                    marginLeft: "6px",
                                                    marginTop: "-3px",
                                                  }}
                                                  icon="warning"
                                                />
                                              )}
                                            </>
                                          );
                                        }
                                      : val?.showBool
                                        ? (rowData) => {
                                            let check = false;
                                            checklistdata.map((val) => {
                                              if (
                                                val?.itemId?.toLowerCase() ==
                                                rowData?.data?.gCheckListItemId?.toLowerCase()
                                              ) {
                                                check = val?.complete;
                                              }
                                              return val;
                                            });

                                            return (
                                              <>
                                                {rowData?.data?.bAllowCheck && (
                                                  <input
                                                    type="checkbox"
                                                    checked={check}
                                                    onChange={() => {
                                                      if (check) {
                                                        let arr = checklistdata.map((val) => {
                                                          if (
                                                            val?.itemId?.toLowerCase() ==
                                                            rowData?.data?.gCheckListItemId?.toLowerCase()
                                                          ) {
                                                            return {
                                                              ...val,
                                                              complete: !val?.complete,
                                                            };
                                                          } else {
                                                            return val;
                                                          }
                                                        });
                                                        setchecklistdata(arr);
                                                      } else {
                                                        let arr = checklistdata.map((val) => {
                                                          if (
                                                            val?.itemId?.toLowerCase() ==
                                                            rowData?.data?.gCheckListItemId?.toLowerCase()
                                                          ) {
                                                            return {
                                                              ...val,
                                                              complete: !val?.complete,
                                                            };
                                                          } else {
                                                            return val;
                                                          }
                                                        });
                                                        setchecklistdata(arr);
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </>
                                            );
                                          }
                                        : val?.Selectionbool
                                          ? (rowData) => {
                                              let data;
                                              locationappend.map((val) => {
                                                if (val.id?.toUpperCase() == rowData?.data?.id?.toUpperCase()) {
                                                  data = true;
                                                }
                                              });

                                              return (
                                                <>
                                                  <input
                                                    type="checkbox"
                                                    checked={data}
                                                    onChange={() => {
                                                      let temp;
                                                      locationappend.map((val) => {
                                                        if (val.id == rowData?.data?.id) {
                                                          temp = true;
                                                        }
                                                      });
                                                      if (temp) {
                                                        setlocationappend(
                                                          locationappend.filter((val) => {
                                                            if (val?.id !== rowData?.data?.id) {
                                                              return val;
                                                            }
                                                          }),
                                                        );
                                                      } else {
                                                        setlocationappend([
                                                          ...locationappend,
                                                          {
                                                            Location: rowData?.data?.Location,
                                                            id: rowData?.data?.id,
                                                          },
                                                        ]);
                                                      }
                                                    }}
                                                  />
                                                </>
                                              );
                                            }
                                          : val?.Selectionbool2
                                            ? (rowData) => {
                                                let data;
                                                locationappend.map((val) => {
                                                  if (val.id?.toUpperCase() == rowData?.data?.id?.toUpperCase()) {
                                                    data = true;
                                                  }
                                                });

                                                return (
                                                  <>
                                                    <input
                                                      type="checkbox"
                                                      checked={data}
                                                      onChange={() => {
                                                        let temp;
                                                        locationappend.map((val) => {
                                                          if (
                                                            val.id.toLocaleLowerCase() ==
                                                            rowData?.data?.id.toLocaleLowerCase()
                                                          ) {
                                                            temp = true;
                                                          }
                                                        });
                                                        if (temp) {
                                                          setlocationappend(
                                                            locationappend.filter((val) => {
                                                              if (
                                                                val?.id.toLocaleLowerCase() !==
                                                                rowData?.data?.id.toLocaleLowerCase()
                                                              ) {
                                                                return val;
                                                              }
                                                            }),
                                                          );
                                                        } else {
                                                          setlocationappend([
                                                            ...locationappend,
                                                            {
                                                              "Entity Type": rowData?.data?.["Entity Type"],
                                                              id: rowData?.data?.id,
                                                            },
                                                          ]);
                                                        }
                                                      }}
                                                    />
                                                  </>
                                                );
                                              }
                                            : val?.Selectionbool3
                                              ? (rowData) => {
                                                  let data;
                                                  DocketSupervisioncheck.map((val) => {
                                                    if (val.ID?.toUpperCase() == rowData?.data?.ID?.toUpperCase()) {
                                                      data = true;
                                                    }
                                                  });
                                                  return (
                                                    <>
                                                      <input
                                                        checked={data}
                                                        onChange={() => {
                                                          let temp;
                                                          DocketSupervisioncheck.map((val) => {
                                                            if (
                                                              val.ID.toLocaleLowerCase() ==
                                                              rowData?.data?.ID.toLocaleLowerCase()
                                                            ) {
                                                              temp = true;
                                                            }
                                                          });
                                                          if (temp) {
                                                            setDocketSupervisioncheck(
                                                              DocketSupervisioncheck.filter((val) => {
                                                                if (
                                                                  val?.ID.toLocaleLowerCase() !==
                                                                  rowData?.data?.ID.toLocaleLowerCase()
                                                                ) {
                                                                  return val;
                                                                }
                                                              }),
                                                            );

                                                            let temp;
                                                            DocketSupervisioncheckdata.map((val) => {
                                                              if (
                                                                val.ID.toLocaleLowerCase() ==
                                                                rowData?.data?.ID.toLocaleLowerCase()
                                                              ) {
                                                                temp = true;
                                                              }
                                                            });

                                                            if (temp) {
                                                              setDocketSupervisioncheckclone([
                                                                ...DocketSupervisioncheckclone,
                                                                rowData?.data,
                                                              ]);
                                                            }
                                                          } else {
                                                            setDocketSupervisioncheck([
                                                              ...DocketSupervisioncheck,
                                                              rowData?.data,
                                                            ]);
                                                          }
                                                        }}
                                                        type="checkbox"
                                                      />
                                                    </>
                                                  );
                                                }
                                              : val?.customSelectBox
                                                ? (rowData) => {
                                                    let temp = true;
                                                    return (
                                                      <>
                                                        <input
                                                          // checked={
                                                          //   selectAll
                                                          //     ? selectAll
                                                          //     : PreDisbursementsReportcheckbox.includes(rowData?.data?.gPersonID)
                                                          //     ? true
                                                          //     : rowData?.data?.bSelect
                                                          // }
                                                          // checked={PreDisbursementsReportcheckbox.includes(rowData?.data?.gPersonID)}
                                                          checked={PreDisbursementsReportcheckbox.includes(
                                                            `${rowData?.data?.gPersonID}_${
                                                              rowData?.data?.FeeCode ||
                                                              rowData?.data?.FeeName ||
                                                              rowData?.rowIndex
                                                            }`,
                                                          )}
                                                          type="checkbox"
                                                          // onChange={() => {
                                                          //   if (!PreDisbursementsReportcheckbox.includes(rowData?.data?.gPersonID)) {
                                                          //     setPreDisbursementsReportcheckbox([
                                                          //       ...PreDisbursementsReportcheckbox,
                                                          //       rowData?.data?.gPersonID,
                                                          //     ]);
                                                          //     temp = false;
                                                          //   } else {
                                                          //     temp = true;
                                                          //     setPreDisbursementsReportcheckbox(
                                                          //       PreDisbursementsReportcheckbox?.filter((val) => {
                                                          //         if (val !== rowData?.data?.gPersonID) {
                                                          //           return val;
                                                          //         }
                                                          //       })
                                                          //     );
                                                          //   }
                                                          // }}
                                                          // onChange={(e) => {
                                                          //   const isChecked = e.target.checked;
                                                          //   const rowAmount = parseFloat(rowData?.data?.Amount) || 0;

                                                          //   if (isChecked) {
                                                          //     setPreDisbursementsReportcheckbox([
                                                          //       ...PreDisbursementsReportcheckbox,
                                                          //       rowData?.data?.gPersonID,
                                                          //     ]);
                                                          //     if (setRecipientCount) setRecipientCount((prev) => prev + 1);
                                                          //     if (setAmountToPay) setAmountToPay((prev) => prev + rowAmount);
                                                          //   } else {
                                                          //     setPreDisbursementsReportcheckbox(
                                                          //       PreDisbursementsReportcheckbox.filter((val) => val !== rowData?.data?.gPersonID)
                                                          //     );
                                                          //     if (setRecipientCount) setRecipientCount((prev) => Math.max(prev - 1, 0));
                                                          //     if (setAmountToPay) setAmountToPay((prev) => Math.max(prev - rowAmount, 0));
                                                          //   }
                                                          // }}
                                                          // onChange={(e) => {
                                                          //   const isChecked = e.target.checked;
                                                          //   const rowAmount = parseFloat(rowData?.data?.Amount) || 0;

                                                          //   let updatedSelections = [];

                                                          //   if (isChecked) {
                                                          //     updatedSelections = [...PreDisbursementsReportcheckbox, rowData?.data?.gPersonID];
                                                          //     setPreDisbursementsReportcheckbox(updatedSelections);

                                                          //     if (setRecipientCount) setRecipientCount((prev) => prev + 1);
                                                          //     if (setAmountToPay) setAmountToPay((prev) => prev + rowAmount);
                                                          //   } else {
                                                          //     updatedSelections = PreDisbursementsReportcheckbox.filter(
                                                          //       (val) => val !== rowData?.data?.gPersonID
                                                          //     );
                                                          //     setPreDisbursementsReportcheckbox(updatedSelections);

                                                          //     if (setRecipientCount) setRecipientCount((prev) => Math.max(prev - 1, 0));
                                                          //     if (setAmountToPay) setAmountToPay((prev) => Math.max(prev - rowAmount, 0));
                                                          //   }
                                                          //   sessionStorage.setItem(
                                                          //     "PreDisbursements_SelectedIDs",
                                                          //     JSON.stringify(updatedSelections)
                                                          //   );
                                                          //   sessionStorage.setItem(
                                                          //     "PreDisbursements_Totals",
                                                          //     JSON.stringify({
                                                          //       count: updatedSelections.length,
                                                          //       amount: updatedSelections.reduce((sum, id) => {
                                                          //         const match = tableRow?.find((row) => row.gPersonID === id);
                                                          //         return sum + (parseFloat(match?.Amount) || 0);
                                                          //       }, 0),
                                                          //     })
                                                          //   );
                                                          // }}
                                                          onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            const rowAmount = parseFloat(rowData?.data?.Amount) || 0;
                                                            // ✅ Generate a unique key for this specific row
                                                            const uniqueKey = `${rowData?.data?.gPersonID}_${
                                                              rowData?.data?.FeeCode ||
                                                              rowData?.data?.FeeName ||
                                                              rowData?.rowIndex
                                                            }`;
                                                            let updatedSelections = [];

                                                            if (isChecked) {
                                                              updatedSelections = [
                                                                ...PreDisbursementsReportcheckbox,
                                                                uniqueKey,
                                                              ];
                                                              setPreDisbursementsReportcheckbox(updatedSelections);
                                                              if (setRecipientCount)
                                                                setRecipientCount((prev) => prev + 1);
                                                              if (setAmountToPay)
                                                                setAmountToPay((prev) => prev + rowAmount);
                                                            } else {
                                                              updatedSelections = PreDisbursementsReportcheckbox.filter(
                                                                (val) => val !== uniqueKey,
                                                              );
                                                              setPreDisbursementsReportcheckbox(updatedSelections);
                                                              if (setRecipientCount)
                                                                setRecipientCount((prev) => Math.max(prev - 1, 0));
                                                              if (setAmountToPay)
                                                                setAmountToPay((prev) => Math.max(prev - rowAmount, 0));
                                                            }

                                                            // ✅ Persist selection and totals in sessionStorage
                                                            sessionStorage.setItem(
                                                              "PreDisbursements_SelectedIDs",
                                                              JSON.stringify(updatedSelections),
                                                            );
                                                            sessionStorage.setItem(
                                                              "PreDisbursements_Totals",
                                                              JSON.stringify({
                                                                count: updatedSelections.length,
                                                                amount: updatedSelections.reduce((sum, id) => {
                                                                  const match = tableRow?.find((row) => {
                                                                    const matchKey = `${row.gPersonID}_${
                                                                      row.FeeCode || row.FeeName || row.rowIndex
                                                                    }`;
                                                                    return matchKey === id;
                                                                  });
                                                                  return sum + (parseFloat(match?.Amount) || 0);
                                                                }, 0),
                                                              }),
                                                            );
                                                          }}
                                                        />
                                                      </>
                                                    );
                                                  }
                                                : val?.DocketManagementSelect
                                                  ? (rowData) => {
                                                      let temp = true;
                                                      return (
                                                        <>
                                                          <input
                                                            checked={
                                                              selectTaskAll
                                                                ? selectTaskAll
                                                                : selectedRowCheckbox.includes(rowData?.data?.ID)
                                                                  ? true
                                                                  : rowData?.data?.bSelect
                                                            }
                                                            type="checkbox"
                                                            onChange={() => {
                                                              if (!selectedRowCheckbox.includes(rowData?.data?.ID)) {
                                                                setSelectedRowCheckbox([
                                                                  ...selectedRowCheckbox,
                                                                  rowData?.data?.ID,
                                                                ]);
                                                                temp = false;
                                                              } else {
                                                                temp = true;
                                                                setSelectedRowCheckbox(
                                                                  selectedRowCheckbox?.filter((val) => {
                                                                    if (val !== rowData?.data?.ID) {
                                                                      return val;
                                                                    }
                                                                  }),
                                                                );
                                                              }
                                                            }}
                                                          />
                                                        </>
                                                      );
                                                    }
                                                  : val?.personListControl && val?.bool
                                                    ? (rowData) => {
                                                        return (
                                                          <>
                                                            <input
                                                              type="checkbox"
                                                              checked={selectedPersonIds?.includes(
                                                                rowData?.data?.["Person ID"],
                                                              )}
                                                              onChange={(e) => {
                                                                if (
                                                                  !selectedPersonIds?.includes(
                                                                    rowData?.data?.["Person ID"],
                                                                  )
                                                                ) {
                                                                  setSelectedPersonIds([
                                                                    ...selectedPersonIds,
                                                                    rowData?.data?.["Person ID"],
                                                                  ]);
                                                                } else {
                                                                  setSelectedPersonIds(
                                                                    selectedPersonIds?.filter((id) => {
                                                                      if (id !== rowData?.data?.["Person ID"])
                                                                        return id;
                                                                    }),
                                                                  );
                                                                }
                                                              }}
                                                            />
                                                          </>
                                                        );
                                                      }
                                                    : val?.docketListControl && val?.bool
                                                      ? (rowData) => {
                                                          return (
                                                            <>
                                                              <input
                                                                type="checkbox"
                                                                checked={selectedPersonIds?.includes(
                                                                  rowData?.data?.gPersonId,
                                                                )}
                                                                onChange={(e) => {
                                                                  const docketId = rowData?.data?.gDocketID;
                                                                  if (
                                                                    !selectedPersonIds?.includes(
                                                                      rowData?.data?.gPersonId,
                                                                    )
                                                                  ) {
                                                                    setSelectedPersonIds([
                                                                      ...selectedPersonIds,
                                                                      rowData?.data?.gPersonId,
                                                                    ]);

                                                                    // Ensure docketId is added only if it's not already in the list
                                                                    if (!selectedDocketIds.includes(docketId)) {
                                                                      setSelectedDocketIds([
                                                                        ...selectedDocketIds,
                                                                        { gDocketId: docketId },
                                                                      ]);
                                                                      setCheckedRows(rowData?.data);
                                                                    }
                                                                  } else {
                                                                    setSelectedPersonIds(
                                                                      selectedPersonIds?.filter(
                                                                        (id) => id !== rowData?.data?.gPersonId,
                                                                      ),
                                                                    );

                                                                    setCheckedRows(
                                                                      selectedPersonIds?.filter(
                                                                        (id) => id !== rowData?.data,
                                                                      ),
                                                                    ); // Remove the associated docketId when the person is unchecked
                                                                    setSelectedDocketIds(
                                                                      selectedDocketIds.filter(
                                                                        (item) => item.gDocketId !== docketId,
                                                                      ),
                                                                    );
                                                                  }
                                                                }}
                                                              />
                                                            </>
                                                          );
                                                        }
                                                      : val?.checkIconBool
                                                        ? (rowData) => {
                                                            return (
                                                              <>
                                                                {rowData?.data?.Active ? (
                                                                  <img src={ActiveIcon} alt={rowData?.data?.Active} />
                                                                ) : (
                                                                  <img
                                                                    src={UnActiveIcon}
                                                                    alt={rowData?.data?.Active}
                                                                    style={{ height: "18px" }}
                                                                  />
                                                                )}
                                                              </>
                                                            );
                                                          }
                                                        : val?.moreoption && taskcontextmenu2
                                                          ? (rowData) => {
                                                              const uniqueId = `threedots-${rowData.data.taskId}`;
                                                              console.log("rowdata", rowData.data);
                                                              return (
                                                                <>
                                                                  <div
                                                                    className="add_navBar_hamburger"
                                                                    id={uniqueId}
                                                                    // id="threedots"
                                                                    // onClick={() => {
                                                                    //   setgettaskEditDAta(rowData?.data);
                                                                    // }}
                                                                  >
                                                                    <ThreeDotMenu />
                                                                    <ContextMenu
                                                                      showEvent="dxclick"
                                                                      dataSource={[
                                                                        {
                                                                          text: "Edit Task",
                                                                          icon: "edit",
                                                                        },
                                                                        {
                                                                          text: "Add Task",
                                                                          icon: "add",
                                                                        },
                                                                        {
                                                                          text: "Jump to Person",
                                                                          icon: "search",
                                                                        },
                                                                        {
                                                                          text: "Pending/Delay 30 Days",
                                                                          icon: "clock",
                                                                        },
                                                                        {
                                                                          text: "Reassign Selected Tasks",
                                                                          icon: "add",
                                                                        },
                                                                        {
                                                                          text: "Task Completed",
                                                                          icon: "check",
                                                                        },
                                                                        {
                                                                          text: "Approve/Process Close-out",
                                                                          disabled:
                                                                            rowData?.data?.categoryId?.toLowerCase() !==
                                                                            "60dded19-3eea-4af8-bc1a-9a37ae4fe85a",
                                                                        },
                                                                        {
                                                                          text: "Approve/Process Allocation Adjustment",
                                                                        },
                                                                        {
                                                                          text: "Approve/Process Refund",
                                                                          // disabled: !(gettaskEditDAta?.categoryId === "A62E2033-D400-4FDB-A4AC-7C78C8813FD4".toLowerCase())
                                                                          disabled: !(
                                                                            gUserId?.toLowerCase() ===
                                                                            gettaskEditDAta?.assignedToId?.toLowerCase()
                                                                          ),
                                                                        },
                                                                      ]}
                                                                      // target="#threedots"
                                                                      target={`#${uniqueId}`}
                                                                      onItemClick={(e) => {
                                                                        setgettaskEditDAta(rowData?.data);
                                                                        if (e.itemData.text === "Edit Task") {
                                                                          // console.log("gettaskEditDAta",gettaskEditDAta)
                                                                          setAddQuickPopup(true);
                                                                          setresettask(!resettask);
                                                                        } else if (e.itemData.text === "Add Task") {
                                                                          setAddQuickPopup(true);
                                                                          setAddTaskPopupType("Add");
                                                                        } else if (
                                                                          e.itemData.text === "Pending/Delay 30 Days"
                                                                        ) {
                                                                          setPendingPOpuptogal(true);
                                                                          setresettask(!resettask);
                                                                        } else if (
                                                                          e.itemData.text === "Task Completed"
                                                                        ) {
                                                                          getCompletTask(false);
                                                                        } else if (
                                                                          e.itemData.text ===
                                                                          "Approve/Process Close-out"
                                                                        ) {
                                                                          const taskId = rowData?.data?.taskId;

                                                                          if (!taskId) {
                                                                            return;
                                                                          }

                                                                          dispatch(
                                                                            setDynamicTab({
                                                                              link: `/process-person-closeout/${taskId}`,
                                                                              title: "Process Person Closeout",
                                                                            }),
                                                                          );

                                                                          navigate(
                                                                            `/process-person-closeout/${taskId}`,
                                                                          );
                                                                        } else if (
                                                                          e.itemData.text ===
                                                                          "Approve/Process Allocation Adjustment"
                                                                        ) {
                                                                          const taskId = rowData?.data?.taskId;
                                                                          const userId =
                                                                            localStorage.getItem("gUserId");

                                                                          if (taskId && userId) {
                                                                            AllocationAdjustment(taskId, userId);
                                                                          } else {
                                                                            console.error(
                                                                              "Task ID or User ID is missing.",
                                                                            );
                                                                          }
                                                                        } else if (
                                                                          e.itemData.text === "Approve/Process Refund"
                                                                        ) {
                                                                          approveRefund();
                                                                        } else if (
                                                                          e.itemData.text === "Reassign Selected Tasks"
                                                                        ) {
                                                                          setReassignTasksPopup(true);
                                                                        } else if (
                                                                          e.itemData.text === "Jump to Person"
                                                                        ) {
                                                                          if (!gettaskEditDAta?.offenderNumber) {
                                                                            return;
                                                                          }
                                                                          dispatch(
                                                                            setDynamicTab({
                                                                              link: `/participant/${gettaskEditDAta?.offenderNumber}`,
                                                                              Offender: gettaskEditDAta?.offenderNumber,
                                                                              title:
                                                                                gettaskEditDAta?.name?.split(",")[0],
                                                                            }),
                                                                          );
                                                                          navigate(
                                                                            `/participant/${gettaskEditDAta?.offenderNumber}`,
                                                                          );
                                                                        }
                                                                      }}
                                                                    />
                                                                  </div>
                                                                </>
                                                              );
                                                            }
                                                          : val?.moreoption && arrearageMinderMenu
                                                            ? (rowData) => {
                                                                return (
                                                                  <>
                                                                    <div
                                                                      className="add_navBar_hamburger"
                                                                      id="threedotsarrearage"
                                                                      onClick={() => {
                                                                        setArrearageRowData(rowData.data);
                                                                      }}
                                                                    >
                                                                      <ThreeDotMenu />
                                                                      <ContextMenu
                                                                        showEvent="dxclick"
                                                                        dataSource={[
                                                                          {
                                                                            text: "Jump to Person",
                                                                            icon: "search",
                                                                          },
                                                                          {
                                                                            text: "Send Arrearage Notification",
                                                                            icon: "email",
                                                                          },
                                                                        ]}
                                                                        target="#threedotsarrearage"
                                                                        onItemClick={(e) => {
                                                                          if (e.itemData.text === "Jump to Person") {
                                                                            if (!arrearageRowData?.["Client Id"]) {
                                                                              return;
                                                                            }
                                                                            dispatch(
                                                                              setDynamicTab({
                                                                                link: `/participant/${arrearageRowData?.["Client Id"]}`,
                                                                                Offender:
                                                                                  arrearageRowData?.["Client Id"],
                                                                                title:
                                                                                  arrearageRowData?.[
                                                                                    "Client Name"
                                                                                  ]?.split(",")[0],
                                                                              }),
                                                                            );
                                                                            navigate(
                                                                              `/participant/${arrearageRowData?.["Client Id"]}`,
                                                                            );
                                                                          } else if (
                                                                            e.itemData.text ===
                                                                            "Send Arrearage Notification"
                                                                          ) {
                                                                            setSendEmailPopup(true);
                                                                          }
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </>
                                                                );
                                                              }
                                                            : val?.moreoption && editInvoiceTable
                                                              ? (rowData) => {
                                                                  return (
                                                                    <>
                                                                      <div
                                                                        className="add_navBar_hamburger"
                                                                        id="threedotsarrearage"
                                                                        onClick={() => {
                                                                          setSelectedItem(rowData?.data);
                                                                        }}
                                                                      >
                                                                        <ThreeDotMenu />
                                                                        <ContextMenu
                                                                          showEvent="dxclick"
                                                                          dataSource={[
                                                                            {
                                                                              text: "Edit Item",
                                                                              icon: "Edit",
                                                                            },
                                                                          ]}
                                                                          target="#threedotsarrearage"
                                                                          onItemClick={(e) => {
                                                                            if (e.itemData.text === "Edit Item") {
                                                                              setEditItemPopup(true);
                                                                            }
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </>
                                                                  );
                                                                }
                                                              : val?.moreoption && revenueReportMenu
                                                                ? (rowData) => {
                                                                    return (
                                                                      <>
                                                                        <div
                                                                          className="add_navBar_hamburger"
                                                                          id="threedotsarrearage"
                                                                          onClick={() => {
                                                                            setRevenueRowData(rowData.data);
                                                                          }}
                                                                        >
                                                                          <ThreeDotMenu />
                                                                          <ContextMenu
                                                                            showEvent="dxclick"
                                                                            dataSource={[
                                                                              {
                                                                                text: "Jump to Person",
                                                                                icon: "search",
                                                                              },
                                                                            ]}
                                                                            target="#threedotsarrearage"
                                                                            onItemClick={(e) => {
                                                                              if (
                                                                                e.itemData.text === "Jump to Person"
                                                                              ) {
                                                                                if (!revenueRowData?.["Client Id"]) {
                                                                                  return;
                                                                                }
                                                                                dispatch(
                                                                                  setDynamicTab({
                                                                                    link: `/participant/${revenueRowData?.["Client Id"]}`,
                                                                                    Offender:
                                                                                      revenueRowData?.["Client Id"],
                                                                                    title:
                                                                                      revenueRowData?.[
                                                                                        "Client Name"
                                                                                      ]?.split(",")[0],
                                                                                  }),
                                                                                );
                                                                                navigate(
                                                                                  `/participant/${revenueRowData?.["Client Id"]}`,
                                                                                );
                                                                              }
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </>
                                                                    );
                                                                  }
                                                                : val?.moreoption && agingReportMenu
                                                                  ? (rowData) => {
                                                                      return (
                                                                        <>
                                                                          <div
                                                                            className="add_navBar_hamburger"
                                                                            id="threedotsarrearage"
                                                                            onClick={() => {
                                                                              setAgingRowData(rowData.data);
                                                                            }}
                                                                          >
                                                                            <ThreeDotMenu />
                                                                            <ContextMenu
                                                                              showEvent="dxclick"
                                                                              dataSource={[
                                                                                {
                                                                                  text: "Jump to Person",
                                                                                  icon: "search",
                                                                                },
                                                                              ]}
                                                                              target="#threedotsarrearage"
                                                                              onItemClick={(e) => {
                                                                                if (
                                                                                  e.itemData.text === "Jump to Person"
                                                                                ) {
                                                                                  if (!agingRowData?.["Client Id"]) {
                                                                                    return;
                                                                                  }
                                                                                  dispatch(
                                                                                    setDynamicTab({
                                                                                      link: `/participant/${agingRowData?.["Client Id"]}`,
                                                                                      Offender:
                                                                                        agingRowData?.["Client Id"],
                                                                                      title:
                                                                                        agingRowData?.[
                                                                                          "Client Name"
                                                                                        ]?.split(",")[0],
                                                                                    }),
                                                                                  );
                                                                                  navigate(
                                                                                    `/participant/${agingRowData?.["Client Id"]}`,
                                                                                  );
                                                                                }
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </>
                                                                      );
                                                                    }
                                                                  : val?.moreoption && DocketManagementRightClick
                                                                    ? (rowData) => {
                                                                        console.log("docketmanagement", rowData);
                                                                        const uniqueId = `threedots-${rowData.data.ID}`;
                                                                        return (
                                                                          <>
                                                                            <div
                                                                              className="add_navBar_hamburger"
                                                                              id={uniqueId}
                                                                            >
                                                                              <ThreeDotMenu />
                                                                              <ContextMenu
                                                                                showEvent="dxclick"
                                                                                dataSource={[
                                                                                  {
                                                                                    text: "Jump To Docket",
                                                                                    icon: "search",
                                                                                  },
                                                                                  // {
                                                                                  //   text: "Quick Add Obligation",
                                                                                  //   disabled: false,
                                                                                  // },
                                                                                  {
                                                                                    text: "Change Supervision Status",
                                                                                    disabled:
                                                                                      !selectedRowCheckbox.length,
                                                                                  },
                                                                                  {
                                                                                    text: "Change Finacial Status",
                                                                                    disabled:
                                                                                      !selectedRowCheckbox.length,
                                                                                  },
                                                                                  {
                                                                                    text: "Change Supervisor",
                                                                                    disabled:
                                                                                      !selectedRowCheckbox.length,
                                                                                  },
                                                                                  {
                                                                                    text: `Add Revocation(${selectedRowCheckbox?.length || 0})`,
                                                                                    // disabled: true,
                                                                                  },
                                                                                  // {
                                                                                  //   text: "Add Revocation(s)",
                                                                                  //   disabled: true,
                                                                                  // },
                                                                                  {
                                                                                    text: `Add Warrants (${selectedRowCheckbox?.length || 0})`,
                                                                                  },
                                                                                  {
                                                                                    text: "Add Tolling",
                                                                                    disabled:
                                                                                      !selectedRowCheckbox.length,
                                                                                  },
                                                                                  {
                                                                                    text: "Move Obligation to Another Docket ",
                                                                                    disabled: true,
                                                                                  },
                                                                                  {
                                                                                    text: "Delete Docket",
                                                                                    disabled: true,
                                                                                  },
                                                                                ]}
                                                                                target={`#${uniqueId}`}
                                                                                onItemClick={(e) => {
                                                                                  if (
                                                                                    e.itemData.text === "Jump To Docket"
                                                                                  ) {
                                                                                    if (
                                                                                      !rowData?.data?.userinfo
                                                                                        ?.gDocketId &&
                                                                                      !rowData?.data?.userinfo
                                                                                        ?.gPersonId
                                                                                    ) {
                                                                                      return;
                                                                                    }
                                                                                    dispatch(
                                                                                      setDynamicTab({
                                                                                        Offender: `/docket/${rowData?.data?.userinfo?.gDocketId}`,
                                                                                        link: `/docket/${rowData?.data?.userinfo?.gDocketId}`,
                                                                                        title: `Docket ${`${rowData?.data?.sDocketNumberCourtCounts}`}`,
                                                                                        sDocketNumberCourtCounts: `${rowData?.data?.sDocketNumberCourtCounts}`,
                                                                                        userinfo: {
                                                                                          ...rowData?.data?.userinfo,
                                                                                          gPersonId:
                                                                                            rowData?.data?.userinfo
                                                                                              ?.gPersonId,
                                                                                        },
                                                                                        getTopDynamicDocketid:
                                                                                          rowData?.data?.userinfo
                                                                                            ?.gDocketId,
                                                                                      }),
                                                                                    );
                                                                                    dispatch(
                                                                                      setdockerValue({
                                                                                        getTopDynamicDocketid:
                                                                                          rowData?.data?.userinfo
                                                                                            ?.gDocketId,
                                                                                        userinfo: {
                                                                                          ...rowData?.data?.userinfo,
                                                                                          gPersonId:
                                                                                            rowData?.data?.userinfo
                                                                                              ?.gPersonId,
                                                                                        },
                                                                                      }),
                                                                                    );
                                                                                    navigate(
                                                                                      `/docket/${rowData?.data?.userinfo?.gDocketId}`,
                                                                                    );
                                                                                  }

                                                                                  // if (e.itemData.text === "Quick Add Obligation") {
                                                                                  //   setHeader({
                                                                                  //     ...header,
                                                                                  //     sDocketNumberCourtCounts: rowData?.data?.["Docket/Count"],
                                                                                  //   });
                                                                                  //   setDocketId(rowData?.data?.userinfo?.gDocketId);
                                                                                  //   dispatch(setRecentDocket(rowData?.data));
                                                                                  //   setgetQuickaddObligationPopup(true);
                                                                                  // }

                                                                                  if (
                                                                                    e.itemData.text ===
                                                                                    "Change Supervision Status"
                                                                                  ) {
                                                                                    setChangesuperviserDatePOpup(true);
                                                                                  }
                                                                                  if (
                                                                                    e.itemData.text ===
                                                                                    `Add Revocation(${selectedRowCheckbox?.length || 0})`
                                                                                  ) {
                                                                                    setAddRevocationspopup(true);
                                                                                  }
                                                                                  if (
                                                                                    e.itemData.text ===
                                                                                    `Add Warrants (${selectedRowCheckbox?.length || 0})`
                                                                                  ) {
                                                                                    setAddWarrentsPopup(true);
                                                                                  }
                                                                                  if (
                                                                                    e.itemData.text ===
                                                                                    "Change Finacial Status"
                                                                                  ) {
                                                                                    setChangeFinancialStatusPopup(true);
                                                                                  }

                                                                                  if (
                                                                                    e.itemData.text ===
                                                                                    "Change Supervisor"
                                                                                  ) {
                                                                                    setChangeSupervisorPopup(true);
                                                                                  }

                                                                                  if (
                                                                                    e.itemData.text === "Add Tolling"
                                                                                  ) {
                                                                                    setAddTollingPopup(true);
                                                                                  }
                                                                                }}
                                                                              />
                                                                            </div>
                                                                          </>
                                                                        );
                                                                      }
                                                                    : val?.addObligation && DocketManagementRightClick
                                                                      ? (rowData) => (
                                                                          <Button
                                                                            icon="add"
                                                                            stylingMode="text"
                                                                            onClick={(e) => {
                                                                              setHeader({
                                                                                ...header,
                                                                                sDocketNumberCourtCounts:
                                                                                  rowData?.data?.["Docket/Count"],
                                                                              });
                                                                              setDocketId(
                                                                                rowData?.data?.userinfo?.gDocketId,
                                                                              );
                                                                              dispatch(setRecentDocket(rowData?.data));
                                                                              setgetQuickaddObligationPopup(true);
                                                                            }}
                                                                          />
                                                                        )
                                                                      : val?.moreoption && Contextmenu
                                                                        ? (rowData) => {
                                                                            const menuId = `threedotsarrearage-${rowData?.key}`;
                                                                            return (
                                                                              <>
                                                                                <div
                                                                                  className="add_navBar_hamburger"
                                                                                  id={menuId}
                                                                                  onClick={() => {
                                                                                    reportdatesdata = rowData?.data;
                                                                                    // setAgingRowData(rowData.data);
                                                                                    if (
                                                                                      setreportDataId &&
                                                                                      editParticipant
                                                                                    ) {
                                                                                      setAttendance(
                                                                                        rowData?.data?.Attendance,
                                                                                      );
                                                                                      setreportDataId(rowData?.key);
                                                                                      setPostReportNote(
                                                                                        rowData?.data?.[
                                                                                          `Pre-Report Note`
                                                                                        ],
                                                                                      );
                                                                                      setdesableReportData(
                                                                                        rowData?.data?.Void,
                                                                                      );
                                                                                    }
                                                                                  }}
                                                                                >
                                                                                  <ThreeDotMenu />
                                                                                  <ContextMenu
                                                                                    showEvent="dxclick"
                                                                                    dataSource={
                                                                                      Attendance
                                                                                        ? [
                                                                                            {
                                                                                              text: "Remove Attendance Status",
                                                                                              icon: "trash",
                                                                                            },
                                                                                            {
                                                                                              text: "Void Appointment",
                                                                                              icon: "remove",
                                                                                              disabled:
                                                                                                desableReportData,
                                                                                            },
                                                                                            {
                                                                                              text: "Print Next Report Date",
                                                                                            },
                                                                                          ]
                                                                                        : [
                                                                                            {
                                                                                              text: "Enter Attendance",
                                                                                              icon: "event",
                                                                                            },
                                                                                            {
                                                                                              text: "Remove Attendance Status",
                                                                                              icon: "trash",
                                                                                            },
                                                                                            {
                                                                                              text: "Void Appointment",
                                                                                              icon: "remove",
                                                                                              disabled:
                                                                                                desableReportData,
                                                                                            },
                                                                                            {
                                                                                              text: "Print Next Report Date",
                                                                                            },
                                                                                          ]
                                                                                    }
                                                                                    target={`#${menuId}`}
                                                                                    onItemClick={async (e) => {
                                                                                      if (
                                                                                        e.itemData.text ===
                                                                                        "Enter Attendance"
                                                                                      ) {
                                                                                        if (enableReportDateTabs) {
                                                                                          dispatch(
                                                                                            setDynamicTab({
                                                                                              link: `/enterattendence/${reportdatesdata?.val?.gPersonId}`,
                                                                                              title: `Report Dates ${reportdatesdata?.val?.sLastFirst?.split(",")[0]}`,
                                                                                            }),
                                                                                          );
                                                                                          dispatch(
                                                                                            set_user_data({
                                                                                              personId:
                                                                                                reportdatesdata?.val
                                                                                                  ?.gPersonId,
                                                                                              preReportNote:
                                                                                                reportdatesdata?.val
                                                                                                  ?.sPreReportNote,
                                                                                              gReportDateScheduleId:
                                                                                                reportdatesdata?.val
                                                                                                  ?.gReportDateScheduleId,
                                                                                              sentanceNote:
                                                                                                sentanceNote,
                                                                                              sOffenderNumber:
                                                                                                reportdatesdata?.val
                                                                                                  ?.sOffenderNumber,
                                                                                            }),
                                                                                          );
                                                                                          navigate(
                                                                                            `/enterattendence/${reportdatesdata?.val?.gPersonId}`,
                                                                                          );
                                                                                        } else {
                                                                                          setenterAttendencePopup(true);
                                                                                        }
                                                                                      } else if (
                                                                                        e.itemData.text ===
                                                                                        "Void Appointment"
                                                                                      ) {
                                                                                        setvoidPopup(true);
                                                                                      } else if (
                                                                                        e.itemData.text ===
                                                                                        "Remove Attendance Status"
                                                                                      ) {
                                                                                        setremoveAttendenceStatus(
                                                                                          !removeAttendenceStatus,
                                                                                        );
                                                                                      } else if (
                                                                                        e.itemData.text ===
                                                                                        "Print Next Report Date"
                                                                                      ) {
                                                                                        setLoading(true);
                                                                                        const selectedReportDate =
                                                                                          reportdatesdata;

                                                                                        if (
                                                                                          !selectedReportDate?.sOffenderNumber
                                                                                        ) {
                                                                                          setToastConfig({
                                                                                            isVisible: true,
                                                                                            type: "error",
                                                                                            message:
                                                                                              "Unable to print because the offender number is missing.",
                                                                                          });
                                                                                          return;
                                                                                        }
                                                                                        await axios
                                                                                          .get(
                                                                                            `${process.env.REACT_APP_CRYSTAL_API_URL}/reports-api/reports/get-print-nrd`,
                                                                                            {
                                                                                              params: {
                                                                                                sOffenderNumber:
                                                                                                  selectedReportDate.sOffenderNumber,
                                                                                                sActivityId:
                                                                                                  selectedReportDate.gPreReportActivityNoteId,
                                                                                              },
                                                                                              headers: {
                                                                                                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                                                                                                Domain: pathname,
                                                                                              },
                                                                                              responseType: "blob",
                                                                                            },
                                                                                          )
                                                                                          .then((val) => {
                                                                                            setLoading(false);
                                                                                            if (val?.data?.size > 20) {
                                                                                              const pdfBlob = new Blob(
                                                                                                [val.data],
                                                                                                {
                                                                                                  type: "application/pdf",
                                                                                                },
                                                                                              );
                                                                                              const pdfUrl =
                                                                                                URL.createObjectURL(
                                                                                                  pdfBlob,
                                                                                                );
                                                                                              const downloadLink =
                                                                                                document.createElement(
                                                                                                  "a",
                                                                                                );
                                                                                              downloadLink.href =
                                                                                                pdfUrl;
                                                                                              downloadLink.download =
                                                                                                "Report_Date" + ".pdf";
                                                                                              downloadLink.style.display =
                                                                                                "none";
                                                                                              document.body.appendChild(
                                                                                                downloadLink,
                                                                                              );
                                                                                              downloadLink.click();
                                                                                              document.body.removeChild(
                                                                                                downloadLink,
                                                                                              );
                                                                                            }
                                                                                          })
                                                                                          .catch((val) => {
                                                                                            setLoading(false);
                                                                                          });
                                                                                      }
                                                                                    }}
                                                                                  />
                                                                                </div>
                                                                              </>
                                                                            );
                                                                          }
                                                                        : val?.moreoption &&
                                                                            DocketObligationTableRightClick
                                                                          ? (rowData) => {
                                                                              return (
                                                                                <>
                                                                                  <div
                                                                                    className="add_navBar_hamburger"
                                                                                    id="threedots"
                                                                                    onClick={() => {
                                                                                      setselectedRow(rowData?.data);
                                                                                      if (setObligationData) {
                                                                                        if (
                                                                                          rowData?.data?.[
                                                                                            "Balance Owed"
                                                                                          ] <= 0
                                                                                        ) {
                                                                                          setdesableGeneratePaymetPLan(
                                                                                            true,
                                                                                          );
                                                                                        } else {
                                                                                          setdesableGeneratePaymetPLan(
                                                                                            false,
                                                                                          );
                                                                                        }

                                                                                        if (
                                                                                          rowData?.data?.[
                                                                                            "Balance Owed"
                                                                                          ] <= 0
                                                                                        ) {
                                                                                          setdesablewriteoff(true);
                                                                                        } else {
                                                                                          setdesablewriteoff(false);
                                                                                        }
                                                                                        setObligationData(
                                                                                          rowData?.data,
                                                                                        );
                                                                                      }
                                                                                    }}
                                                                                  >
                                                                                    <ThreeDotMenu />
                                                                                    <ContextMenu
                                                                                      showEvent="dxclick"
                                                                                      dataSource={[
                                                                                        {
                                                                                          text: "Generate Payment Plan",
                                                                                          disabled:
                                                                                            desableGeneratePaymetPLan,
                                                                                        },
                                                                                        {
                                                                                          text: "Write Off Amount",
                                                                                          disabled: desablewriteoff,
                                                                                        },
                                                                                        { text: "Go To Obligation" },
                                                                                      ]}
                                                                                      target="#threedots"
                                                                                      onItemClick={(e) => {
                                                                                        if (
                                                                                          e.itemData.text ===
                                                                                          "Generate Payment Plan"
                                                                                        ) {
                                                                                          if (
                                                                                            setopenGeneratePaymentPlanpopup
                                                                                          ) {
                                                                                            setopenGeneratePaymentPlanpopup(
                                                                                              true,
                                                                                            );
                                                                                          }
                                                                                        } else if (
                                                                                          e.itemData.text ===
                                                                                          "Write Off Amount"
                                                                                        ) {
                                                                                          if (setWrieOffpopup) {
                                                                                            setWrieOffpopup(true);
                                                                                          }
                                                                                        } else if (
                                                                                          e.itemData.text ===
                                                                                          "Go To Obligation"
                                                                                        ) {
                                                                                          setgeneratePaymenttogal(
                                                                                            (prev) => !prev,
                                                                                          );
                                                                                          if (!selectedRow) {
                                                                                            return;
                                                                                          }
                                                                                          dispatch(
                                                                                            setAddObligation(false),
                                                                                          );
                                                                                          dispatch(
                                                                                            setDynamicTab({
                                                                                              Offender: `/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`,
                                                                                              link: `/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`,
                                                                                              title: `Obligation : ${selectedRow?.sDocketNumberCourtCounts} / ${selectedRow?.["Obligation Ref#"]}`,
                                                                                              sDocketNumberCourtCounts:
                                                                                                selectedRow?.sDocketNumberCourtCounts,
                                                                                              ObligationRef:
                                                                                                selectedRow?.[
                                                                                                  "Obligation Ref#"
                                                                                                ],
                                                                                              gObligationId:
                                                                                                selectedRow?.gObligationId,
                                                                                              userinfo:
                                                                                                selectedRow?.userinfo,
                                                                                            }),
                                                                                          );
                                                                                          dispatch(
                                                                                            setgotooblogationValue({
                                                                                              gObligationId:
                                                                                                selectedRow?.gObligationId,
                                                                                              userinfo:
                                                                                                selectedRow?.userinfo,
                                                                                              gDocketId:
                                                                                                selectedRow?.gDocketId,
                                                                                              docketRef:
                                                                                                dockerHeaderData?.sReference,
                                                                                            }),
                                                                                          );
                                                                                          navigate(
                                                                                            `/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`,
                                                                                          );
                                                                                        }
                                                                                      }}
                                                                                    />
                                                                                  </div>
                                                                                </>
                                                                              );
                                                                            }
                                                                          : val?.moreoption && attachmentRightCickPopup
                                                                            ? (rowData) => {
                                                                                console.log("rowdata", rowData);
                                                                                const menuId = `attachment-menu-${rowData.data.binaryDataId}`;
                                                                                return (
                                                                                  <>
                                                                                    {/* <div className="add_navBar_hamburger" id="threedotsarrearage"> */}
                                                                                    <div
                                                                                      className="add_navBar_hamburger"
                                                                                      id={menuId}
                                                                                    >
                                                                                      <ThreeDotMenu />
                                                                                      <ContextMenu
                                                                                        showEvent="dxclick"
                                                                                        dataSource={[
                                                                                          {
                                                                                            text: "Email Attachment",
                                                                                            icon: "email",
                                                                                          },
                                                                                          {
                                                                                            text: "Delete",
                                                                                            icon: "remove",
                                                                                          },
                                                                                        ]}
                                                                                        // target="#threedotsarrearage"
                                                                                        target={`#${menuId}`}
                                                                                        onItemClick={(e) => {
                                                                                          if (
                                                                                            e.itemData.text === "Delete"
                                                                                          ) {
                                                                                            if (
                                                                                              attachmentRightCickPopup
                                                                                            ) {
                                                                                              console.log(
                                                                                                "Inline Delete clicked",
                                                                                                rowData.data,
                                                                                              );
                                                                                              setSelectedAttachment(
                                                                                                rowData.data,
                                                                                              );
                                                                                              setselectedRow(
                                                                                                rowData.data,
                                                                                              );
                                                                                              setgetbinaryDataIdInAttachment &&
                                                                                                setgetbinaryDataIdInAttachment(
                                                                                                  rowData.data
                                                                                                    .binaryDataId,
                                                                                                );
                                                                                              setattachmentdeletePopup(
                                                                                                true,
                                                                                              );
                                                                                            }
                                                                                          }
                                                                                        }}
                                                                                      />
                                                                                    </div>
                                                                                  </>
                                                                                );
                                                                              }
                                                                            : val?.moreoption && taskcontextmenu
                                                                              ? (rowData) => {
                                                                                  console.log("task row data", rowData);
                                                                                  return (
                                                                                    <>
                                                                                      <div
                                                                                        className="add_navBar_hamburger"
                                                                                        id={`threedotsarrearage-${rowData.data.ID}`}
                                                                                        onClick={() => {
                                                                                          // setArrearageRowData(rowData.data);
                                                                                          setgettaskEditDAta(
                                                                                            rowData.data,
                                                                                          );
                                                                                        }}
                                                                                      >
                                                                                        <ThreeDotMenu />
                                                                                        <ContextMenu
                                                                                          showEvent="dxclick"
                                                                                          dataSource={[
                                                                                            {
                                                                                              text: "Edit Task",
                                                                                              icon: "edit",
                                                                                            },
                                                                                            {
                                                                                              text: "Pending/Delay 30 Days",
                                                                                              icon: "clock",
                                                                                            },
                                                                                            {
                                                                                              text: "Complete Task",
                                                                                              icon: "check",
                                                                                            },
                                                                                          ]}
                                                                                          target={`#threedotsarrearage-${rowData.data.ID}`}
                                                                                          onItemClick={(e) => {
                                                                                            if (
                                                                                              e.itemData.text ===
                                                                                              "Edit Task"
                                                                                            ) {
                                                                                              if (setAddQuickPopup) {
                                                                                                setgettaskEditDAta(
                                                                                                  rowData.data,
                                                                                                );
                                                                                                setAddQuickPopup(true);
                                                                                                setresettask(
                                                                                                  !resettask,
                                                                                                );
                                                                                              }
                                                                                            } else if (
                                                                                              e.itemData.text ===
                                                                                              "Pending/Delay 30 Days"
                                                                                            ) {
                                                                                              setPendingPOpuptogal(
                                                                                                true,
                                                                                              );
                                                                                              setresettask(!resettask);
                                                                                            } else if (
                                                                                              e.itemData.text ===
                                                                                              "Complete Task"
                                                                                            ) {
                                                                                              getCompletTask(false);
                                                                                            }
                                                                                          }}
                                                                                        />
                                                                                      </div>
                                                                                    </>
                                                                                  );
                                                                                }
                                                                              : val?.moreoption &&
                                                                                  CheckListTableRightClick
                                                                                ? (rowData) => {
                                                                                    return (
                                                                                      <>
                                                                                        <div
                                                                                          className="add_navBar_hamburger"
                                                                                          id="threedotsarrearage"
                                                                                          onClick={() => {
                                                                                            setgetCheckLIstActivity(
                                                                                              rowData.data,
                                                                                            );
                                                                                          }}
                                                                                        >
                                                                                          <ThreeDotMenu />
                                                                                          <ContextMenu
                                                                                            showEvent="dxclick"
                                                                                            dataSource={[
                                                                                              {
                                                                                                text: "Edit Note",
                                                                                                icon: "edit",
                                                                                              },
                                                                                            ]}
                                                                                            target="#threedotsarrearage"
                                                                                            onItemClick={(e) => {
                                                                                              if (
                                                                                                e.itemData.text ===
                                                                                                "Edit Note"
                                                                                              ) {
                                                                                                if (
                                                                                                  CheckListTableRightClick
                                                                                                ) {
                                                                                                  setresetCHecklist(
                                                                                                    !CHecklistreset,
                                                                                                  );
                                                                                                  seteditCHeckoutNotePOpup(
                                                                                                    true,
                                                                                                  );
                                                                                                }
                                                                                              }
                                                                                            }}
                                                                                          />
                                                                                        </div>
                                                                                      </>
                                                                                    );
                                                                                  }
                                                                                : val?.moreoption &&
                                                                                    Revocationscontextmenu
                                                                                  ? (rowData) => {
                                                                                      const targetId = `revocation-${rowData.data.gRevocationId}`;
                                                                                      return (
                                                                                        <>
                                                                                          {/* <div className="add_navBar_hamburger" id="threedotsarrearage"> */}
                                                                                          <div
                                                                                            className="add_navBar_hamburger"
                                                                                            id={targetId}
                                                                                          >
                                                                                            <ThreeDotMenu />
                                                                                            <ContextMenu
                                                                                              showEvent="dxclick"
                                                                                              dataSource={[
                                                                                                {
                                                                                                  text: "Edit Revocation",
                                                                                                  icon: "edit",
                                                                                                },
                                                                                                {
                                                                                                  text: "Void Revocation",
                                                                                                  icon: "remove",
                                                                                                  disabled:
                                                                                                    desableRevocation,
                                                                                                },
                                                                                              ]}
                                                                                              // target="#threedotsarrearage"
                                                                                              target={`#${targetId}`}
                                                                                              onItemClick={(e) => {
                                                                                                if (
                                                                                                  e.itemData.text ===
                                                                                                  "Edit Revocation"
                                                                                                ) {
                                                                                                  if (
                                                                                                    seteditRevocationspopup
                                                                                                  ) {
                                                                                                    setgetEDitdataRevocations(
                                                                                                      rowData.data,
                                                                                                    );
                                                                                                    seteditRevocationspopup(
                                                                                                      true,
                                                                                                    );
                                                                                                  }
                                                                                                } else if (
                                                                                                  e.itemData.text ===
                                                                                                  "Void Revocation"
                                                                                                ) {
                                                                                                  setVoidPopup(true);
                                                                                                }
                                                                                              }}
                                                                                            />
                                                                                          </div>
                                                                                        </>
                                                                                      );
                                                                                    }
                                                                                  : val?.moreoption &&
                                                                                      EMPeriodcontextmenu
                                                                                    ? (rowData) => {
                                                                                        return (
                                                                                          <>
                                                                                            <div
                                                                                              className="add_navBar_hamburger"
                                                                                              id="threedotsarrearage"
                                                                                              onClick={() => {
                                                                                                setgetEDitdataEmPeriod(
                                                                                                  rowData.data,
                                                                                                );
                                                                                              }}
                                                                                            >
                                                                                              <ThreeDotMenu />
                                                                                              <ContextMenu
                                                                                                showEvent="dxclick"
                                                                                                dataSource={[
                                                                                                  {
                                                                                                    text: "Add EM Period",
                                                                                                    icon: "add",
                                                                                                  },
                                                                                                  {
                                                                                                    text: "Edit EM Period",
                                                                                                    icon: "edit",
                                                                                                  },
                                                                                                  {
                                                                                                    text: "Void EM Period",
                                                                                                    icon: "remove",
                                                                                                  },
                                                                                                ]}
                                                                                                target="#threedotsarrearage"
                                                                                                onItemClick={(e) => {
                                                                                                  if (
                                                                                                    e.itemData.text ===
                                                                                                    "Add EM Period"
                                                                                                  ) {
                                                                                                    setEMPriodpopshow(
                                                                                                      true,
                                                                                                    );
                                                                                                  } else if (
                                                                                                    e.itemData.text ===
                                                                                                    "Edit EM Period"
                                                                                                  ) {
                                                                                                    setEMPriodeditpopshow(
                                                                                                      true,
                                                                                                    );
                                                                                                  } else if (
                                                                                                    e.itemData.text ===
                                                                                                    "Void EM Period"
                                                                                                  ) {
                                                                                                    setEMPeriodConfirmPopup(
                                                                                                      true,
                                                                                                    );
                                                                                                  }
                                                                                                }}
                                                                                              />
                                                                                            </div>
                                                                                          </>
                                                                                        );
                                                                                      }
                                                                                    : val?.moreoption &&
                                                                                        PreDisbursementsReporteightclick
                                                                                      ? (rowData) => {
                                                                                          return (
                                                                                            <>
                                                                                              <div
                                                                                                className="add_navBar_hamburger"
                                                                                                id="threedotsarrearage"
                                                                                                onClick={() => {
                                                                                                  setdisbursementrowdata(
                                                                                                    rowData.data,
                                                                                                  );
                                                                                                }}
                                                                                              >
                                                                                                <ThreeDotMenu />
                                                                                                <ContextMenu
                                                                                                  showEvent="dxclick"
                                                                                                  dataSource={[
                                                                                                    {
                                                                                                      text: "Jump To Person",
                                                                                                      icon: "search",
                                                                                                    },
                                                                                                    {
                                                                                                      text: "Jump To Obligation",
                                                                                                      icon: "search",
                                                                                                    },
                                                                                                    {
                                                                                                      text: "Jump To Docket",
                                                                                                      icon: "search",
                                                                                                    },
                                                                                                    // {
                                                                                                    //   text: "Select All",
                                                                                                    // },
                                                                                                    // {
                                                                                                    //   text: "Select None",
                                                                                                    // },
                                                                                                    // {
                                                                                                    //   text: "Print Checks",
                                                                                                    // },
                                                                                                  ]}
                                                                                                  target="#threedotsarrearage"
                                                                                                  onItemClick={(e) => {
                                                                                                    if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Jump To Person"
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !disbursementrowdata ||
                                                                                                        !disbursementrowdata?.[
                                                                                                          "Offender #"
                                                                                                        ]
                                                                                                      ) {
                                                                                                        return;
                                                                                                      }
                                                                                                      dispatch(
                                                                                                        setDynamicTab({
                                                                                                          link: `/participant/${disbursementrowdata?.["Offender #"]}`,
                                                                                                          Offender:
                                                                                                            disbursementrowdata?.[
                                                                                                              "Offender #"
                                                                                                            ],
                                                                                                          title:
                                                                                                            disbursementrowdata?.[
                                                                                                              "Person Name"
                                                                                                            ]?.split(
                                                                                                              ",",
                                                                                                            )[0],
                                                                                                        }),
                                                                                                      );
                                                                                                      navigate(
                                                                                                        `/participant/${disbursementrowdata?.["Offender #"]}`,
                                                                                                      );
                                                                                                    } else if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Jump To Docket"
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !disbursementrowdata ||
                                                                                                        disbursementrowdata
                                                                                                          ?.userinfo
                                                                                                          ?.gPersonID ==
                                                                                                          null
                                                                                                      ) {
                                                                                                        return;
                                                                                                      }
                                                                                                      dispatch(
                                                                                                        setDynamicTab({
                                                                                                          Offender: `/docket/${disbursementrowdata?.userinfo?.gDocketID}`,
                                                                                                          link: `/docket/${disbursementrowdata?.userinfo?.gDocketID}`,
                                                                                                          title: `Docket ${`${"tempdata2"} - ${"tempdata2"}`}`,
                                                                                                          sDocketNumberCourtCounts: `${"tempdata2"} - ${"tempdata2"}`,
                                                                                                          userinfo: {
                                                                                                            ...disbursementrowdata?.userinfo,
                                                                                                            gPersonId:
                                                                                                              disbursementrowdata
                                                                                                                ?.userinfo
                                                                                                                ?.gPersonID,
                                                                                                          },
                                                                                                          getTopDynamicDocketid:
                                                                                                            disbursementrowdata
                                                                                                              ?.userinfo
                                                                                                              ?.gDocketID,
                                                                                                        }),
                                                                                                      );
                                                                                                      dispatch(
                                                                                                        setdockerValue({
                                                                                                          getTopDynamicDocketid:
                                                                                                            disbursementrowdata
                                                                                                              ?.userinfo
                                                                                                              ?.gDocketID,
                                                                                                          userinfo: {
                                                                                                            ...disbursementrowdata?.userinfo,
                                                                                                            gPersonId:
                                                                                                              disbursementrowdata
                                                                                                                ?.userinfo
                                                                                                                ?.gPersonID,
                                                                                                          },
                                                                                                        }),
                                                                                                      );
                                                                                                      navigate(
                                                                                                        `/docket/${disbursementrowdata?.userinfo?.gDocketID}`,
                                                                                                      );
                                                                                                    } else if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Jump To Obligation"
                                                                                                    ) {
                                                                                                      dispatch(
                                                                                                        setDynamicTab({
                                                                                                          Offender: `/obligation/${disbursementrowdata?.gObligationID}/${"tempdata"}`,
                                                                                                          link: `/obligation/${disbursementrowdata?.gObligationID}/${"tempdata"}`,
                                                                                                          title: `Obligation : ${`${disbursementrowdata?.["sReference"]} - ${disbursementrowdata?.["sReference"]}`} / ${"tempdata"}`,
                                                                                                          sDocketNumberCourtCounts: `${disbursementrowdata?.["sReference"]} - ${disbursementrowdata?.["sReference"]}`,
                                                                                                          ObligationRef:
                                                                                                            "tempdata",
                                                                                                          gObligationId:
                                                                                                            disbursementrowdata?.gObligationID,
                                                                                                          userinfo: {
                                                                                                            ...disbursementrowdata?.userinfo,
                                                                                                            gPersonId:
                                                                                                              disbursementrowdata
                                                                                                                ?.userinfo
                                                                                                                ?.gPersonID,
                                                                                                          },
                                                                                                        }),
                                                                                                      );
                                                                                                      dispatch(
                                                                                                        setgotooblogationValue(
                                                                                                          {
                                                                                                            gObligationId:
                                                                                                              disbursementrowdata?.gObligationID,
                                                                                                            userinfo: {
                                                                                                              ...disbursementrowdata?.userinfo,
                                                                                                              gPersonId:
                                                                                                                disbursementrowdata
                                                                                                                  ?.userinfo
                                                                                                                  ?.gPersonID,
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      );
                                                                                                      navigate(
                                                                                                        `/obligation/${disbursementrowdata?.gObligationID}/${"tempdata"}`,
                                                                                                      );
                                                                                                    } else if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Select All"
                                                                                                    ) {
                                                                                                      setselectAll(
                                                                                                        true,
                                                                                                      );
                                                                                                    } else if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Select None"
                                                                                                    ) {
                                                                                                      setPreDisbursementsReportcheckbox(
                                                                                                        [],
                                                                                                      );
                                                                                                      setselectAll(
                                                                                                        false,
                                                                                                      );
                                                                                                    } else if (
                                                                                                      e.itemData
                                                                                                        .text ===
                                                                                                      "Print Checks"
                                                                                                    ) {
                                                                                                      setPrintCheckPopup(
                                                                                                        true,
                                                                                                      );
                                                                                                    }
                                                                                                  }}
                                                                                                />
                                                                                              </div>
                                                                                            </>
                                                                                          );
                                                                                        }
                                                                                      : val?.moreoption &&
                                                                                          val?.personListControl
                                                                                        ? (rowData) => {
                                                                                            const uniqueId = `threedotsarrearage-${rowData.data["Offender #"]}`;
                                                                                            //  console.log("uniqueId",uniqueId)
                                                                                            return (
                                                                                              <>
                                                                                                <div
                                                                                                  className="add_navBar_hamburger"
                                                                                                  // id="threedotsarrearage"
                                                                                                  id={uniqueId}
                                                                                                  onClick={() => {
                                                                                                    selected =
                                                                                                      rowData.data;
                                                                                                    source =
                                                                                                      rowData.data[
                                                                                                        "Offender #"
                                                                                                      ];
                                                                                                    last = `${rowData.data["Last Name"]}, ${rowData.data["First Name"]}`;
                                                                                                  }}
                                                                                                >
                                                                                                  <ThreeDotMenu />

                                                                                                  <ContextMenu
                                                                                                    showEvent="dxclick"
                                                                                                    dataSource={[
                                                                                                      {
                                                                                                        text: "Jump To Person",
                                                                                                        icon: "search",
                                                                                                      },
                                                                                                      {
                                                                                                        text: "Send Email",
                                                                                                        icon: "email",
                                                                                                      },
                                                                                                      {
                                                                                                        text: "Merge person",
                                                                                                      },
                                                                                                    ]}
                                                                                                    // target="#threedotsarrearage"
                                                                                                    target={`#${uniqueId}`}
                                                                                                    onItemClick={(
                                                                                                      e,
                                                                                                    ) => {
                                                                                                      if (
                                                                                                        e.itemData
                                                                                                          .text ===
                                                                                                        "Jump To Person"
                                                                                                      ) {
                                                                                                        if (
                                                                                                          selected?.gMergePersonID
                                                                                                        ) {
                                                                                                          setMergedPerson(
                                                                                                            selected?.gMergePersonID,
                                                                                                          );
                                                                                                          setConfirmPopup(
                                                                                                            true,
                                                                                                          );
                                                                                                        } else {
                                                                                                          if (
                                                                                                            selected?.personlistfullName
                                                                                                          ) {
                                                                                                            saveCookieCrum(
                                                                                                              selected?.gPersonID,
                                                                                                            );
                                                                                                            dispatch(
                                                                                                              setDynamicTab(
                                                                                                                {
                                                                                                                  link: `/participant/${selected["Offender #"]}`,
                                                                                                                  Offender:
                                                                                                                    selected[
                                                                                                                      "Offender #"
                                                                                                                    ],
                                                                                                                  title:
                                                                                                                    selected?.personlistfullName,
                                                                                                                },
                                                                                                              ),
                                                                                                            );
                                                                                                          } else {
                                                                                                            saveCookieCrum(
                                                                                                              selected?.gPersonId,
                                                                                                            );
                                                                                                            dispatch(
                                                                                                              setDynamicTab(
                                                                                                                {
                                                                                                                  link: `/participant/${selected["Offender #"]}`,
                                                                                                                  Offender:
                                                                                                                    selected[
                                                                                                                      "Offender #"
                                                                                                                    ],
                                                                                                                  title:
                                                                                                                    selected?.sLastName,
                                                                                                                },
                                                                                                              ),
                                                                                                            );
                                                                                                          }

                                                                                                          navigate(
                                                                                                            `/participant/${selected["Offender #"]}`,
                                                                                                          );
                                                                                                        }
                                                                                                      }

                                                                                                      if (
                                                                                                        e.itemData
                                                                                                          .text ===
                                                                                                        "Send Email"
                                                                                                      ) {
                                                                                                        showSendEmailPopup();
                                                                                                      }
                                                                                                      if (
                                                                                                        e.itemData
                                                                                                          .text ===
                                                                                                        "Merge person"
                                                                                                      ) {
                                                                                                        setPerson(
                                                                                                          selected?.gPersonID,
                                                                                                        );
                                                                                                        setLast(last);
                                                                                                        setSourcePersonId(
                                                                                                          source,
                                                                                                        );
                                                                                                        setMergedPerson(
                                                                                                          selected?.gMergePersonID,
                                                                                                        );
                                                                                                        if (
                                                                                                          selected?.gMergePersonID
                                                                                                        ) {
                                                                                                          setConfirmPopup(
                                                                                                            true,
                                                                                                          );
                                                                                                        } else {
                                                                                                          setIsMergePopupVisible(
                                                                                                            true,
                                                                                                          );
                                                                                                        }
                                                                                                      }
                                                                                                    }}
                                                                                                  />
                                                                                                </div>
                                                                                              </>
                                                                                            );
                                                                                          }
                                                                                        : val?.moreoption &&
                                                                                            periodSummaryControl
                                                                                          ? (rowData) => {
                                                                                              return (
                                                                                                <>
                                                                                                  <div
                                                                                                    className="add_navBar_hamburger"
                                                                                                    id="threedotsPeriodSummary"
                                                                                                    onClick={() => {
                                                                                                      setSelectedPersonIds(
                                                                                                        rowData.data,
                                                                                                      );
                                                                                                    }}
                                                                                                  >
                                                                                                    <ThreeDotMenu />
                                                                                                    <ContextMenu
                                                                                                      showEvent="dxclick"
                                                                                                      dataSource={[
                                                                                                        {
                                                                                                          text: "Jump To Person",
                                                                                                          icon: "search",
                                                                                                        },
                                                                                                      ]}
                                                                                                      target="#threedotsPeriodSummary"
                                                                                                      onItemClick={(
                                                                                                        e,
                                                                                                      ) => {
                                                                                                        if (
                                                                                                          e.itemData
                                                                                                            ?.text ===
                                                                                                          "Jump To Person"
                                                                                                        ) {
                                                                                                          if (
                                                                                                            selectedPersonIds[
                                                                                                              "Offender Name"
                                                                                                            ]
                                                                                                          ) {
                                                                                                            saveCookieCrum(
                                                                                                              selectedPersonIds[
                                                                                                                "Offender #"
                                                                                                              ],
                                                                                                            );
                                                                                                            dispatch(
                                                                                                              setDynamicTab(
                                                                                                                {
                                                                                                                  link: `/participant/${selectedPersonIds["Offender #"]}`,
                                                                                                                  Offender:
                                                                                                                    selectedPersonIds[
                                                                                                                      "Offender #"
                                                                                                                    ],
                                                                                                                  title:
                                                                                                                    selectedPersonIds[
                                                                                                                      "Offender Name"
                                                                                                                    ]?.split(
                                                                                                                      ",",
                                                                                                                    )[0],
                                                                                                                },
                                                                                                              ),
                                                                                                            );
                                                                                                          }
                                                                                                          navigate(
                                                                                                            `/participant/${selectedPersonIds["Offender #"]}`,
                                                                                                          );
                                                                                                        }
                                                                                                      }}
                                                                                                    />
                                                                                                  </div>
                                                                                                </>
                                                                                              );
                                                                                            }
                                                                                          : val?.moreoption &&
                                                                                              val?.docketListControl
                                                                                            ? (rowData) => {
                                                                                                return (
                                                                                                  <>
                                                                                                    <div
                                                                                                      className="add_navBar_hamburger"
                                                                                                      id="threedotsarrearage"
                                                                                                      onClick={() => {
                                                                                                        selected =
                                                                                                          rowData.data;
                                                                                                      }}
                                                                                                    >
                                                                                                      <ThreeDotMenu />
                                                                                                      <ContextMenu
                                                                                                        showEvent="dxclick"
                                                                                                        dataSource={[
                                                                                                          {
                                                                                                            text: "Jump To Docket",
                                                                                                            icon: "search",
                                                                                                          },
                                                                                                          {
                                                                                                            text: "Send Email",
                                                                                                            icon: "email",
                                                                                                          },
                                                                                                          {
                                                                                                            text: "Change Supervisor",
                                                                                                          },
                                                                                                        ]}
                                                                                                        target="#threedotsarrearage"
                                                                                                        onItemClick={(
                                                                                                          e,
                                                                                                        ) => {
                                                                                                          if (
                                                                                                            e.itemData
                                                                                                              .text ===
                                                                                                            "Jump To Docket"
                                                                                                          ) {
                                                                                                            dispatch(
                                                                                                              setDynamicTab(
                                                                                                                {
                                                                                                                  Offender: `/docket/${selected?.gDocketID}`,
                                                                                                                  link: `/docket/${selected?.gDocketID}`,
                                                                                                                  title: `Docket ${selected?.sDocketNumberCourtCounts}`,
                                                                                                                  sDocketNumberCourtCounts:
                                                                                                                    selected?.sDocketNumberCourtCounts,
                                                                                                                  userinfo:
                                                                                                                    {
                                                                                                                      ...selected?.userinfo,
                                                                                                                      gPersonId:
                                                                                                                        selected
                                                                                                                          ?.userinfo
                                                                                                                          ?.gPersonID,
                                                                                                                    },
                                                                                                                  getTopDynamicDocketid:
                                                                                                                    selected?.gDocketID,
                                                                                                                },
                                                                                                              ),
                                                                                                            );
                                                                                                            dispatch(
                                                                                                              setdockerValue(
                                                                                                                {
                                                                                                                  getTopDynamicDocketid:
                                                                                                                    selected?.gDocketID,
                                                                                                                  userinfo:
                                                                                                                    {
                                                                                                                      ...selected?.userinfo,
                                                                                                                      gPersonId:
                                                                                                                        selected
                                                                                                                          ?.userinfo
                                                                                                                          ?.gPersonID,
                                                                                                                    },
                                                                                                                },
                                                                                                              ),
                                                                                                            );
                                                                                                            navigate(
                                                                                                              `/docket/${selected?.gDocketID}`,
                                                                                                            );
                                                                                                          }

                                                                                                          if (
                                                                                                            e.itemData
                                                                                                              .text ===
                                                                                                            "Send Email"
                                                                                                          ) {
                                                                                                            showSendEmailPopup();
                                                                                                            setSendEmail(
                                                                                                              true,
                                                                                                            );
                                                                                                          }
                                                                                                          if (
                                                                                                            e.itemData
                                                                                                              .text ===
                                                                                                            "Change Supervisor"
                                                                                                          ) {
                                                                                                            if (
                                                                                                              !selectedPersonIds.length
                                                                                                            ) {
                                                                                                              showSendEmailPopup();
                                                                                                              return;
                                                                                                            } else {
                                                                                                              setSupervisorChangePopup(
                                                                                                                true,
                                                                                                              );
                                                                                                            }
                                                                                                          }
                                                                                                        }}
                                                                                                      />
                                                                                                    </div>
                                                                                                  </>
                                                                                                );
                                                                                              }
                                                                                            : val?.note
                                                                                              ? (rowData) => {
                                                                                                  return (
                                                                                                    <div
                                                                                                      className="note-cell"
                                                                                                      style={{
                                                                                                        whiteSpace:
                                                                                                          "pre-wrap",
                                                                                                        overflowWrap:
                                                                                                          "anywhere",
                                                                                                        wordBreak:
                                                                                                          "break-word",
                                                                                                        lineHeight:
                                                                                                          "1.4",
                                                                                                      }}
                                                                                                    >
                                                                                                      {rowData.value ??
                                                                                                        ""}
                                                                                                    </div>
                                                                                                  );
                                                                                                }
                                                                                              : val?.moreoption &&
                                                                                                  conditionVerbiageMenu
                                                                                                ? (rowData) => {
                                                                                                    // console.log("rowData.data.obj",rowData)
                                                                                                    const uniqueId = `threedots-verbiage-${rowData.data.ID}`;
                                                                                                    return (
                                                                                                      <>
                                                                                                        <div
                                                                                                          className="add_navBar_hamburger"
                                                                                                          id={uniqueId}
                                                                                                          onClick={() => {
                                                                                                            setEditVerbiageRowData(
                                                                                                              rowData
                                                                                                                .data
                                                                                                                .obj,
                                                                                                            );
                                                                                                          }}
                                                                                                        >
                                                                                                          <ThreeDotMenu />
                                                                                                          <ContextMenu
                                                                                                            showEvent="dxclick"
                                                                                                            dataSource={[
                                                                                                              {
                                                                                                                text: "Edit Verbiage",
                                                                                                                icon: "edit",
                                                                                                              },
                                                                                                            ]}
                                                                                                            target={`#${uniqueId}`}
                                                                                                            onItemClick={(
                                                                                                              e,
                                                                                                            ) => {
                                                                                                              if (
                                                                                                                e
                                                                                                                  .itemData
                                                                                                                  .text ===
                                                                                                                "Edit Verbiage"
                                                                                                              ) {
                                                                                                                setEditVerbiageMode(
                                                                                                                  "EDIT",
                                                                                                                );
                                                                                                                setEditVerbiagePopupOpen(
                                                                                                                  true,
                                                                                                                );
                                                                                                                setEditVerbiageRowData(
                                                                                                                  rowData
                                                                                                                    .data
                                                                                                                    .obj,
                                                                                                                );
                                                                                                              }
                                                                                                            }}
                                                                                                          />
                                                                                                        </div>
                                                                                                      </>
                                                                                                    );
                                                                                                  }
                                                                                                : val?.moreoption &&
                                                                                                    OffensesMenu
                                                                                                  ? (rowData) => {
                                                                                                      const uniqueId = `threedots-verbiage-${rowData.data.ID}`;
                                                                                                      return (
                                                                                                        <>
                                                                                                          <div
                                                                                                            className="add_navBar_hamburger"
                                                                                                            id={
                                                                                                              uniqueId
                                                                                                            }
                                                                                                            onClick={() => {
                                                                                                              setOffenseRowData(
                                                                                                                rowData
                                                                                                                  .data
                                                                                                                  .obj,
                                                                                                              );
                                                                                                            }}
                                                                                                          >
                                                                                                            <ThreeDotMenu />
                                                                                                            <ContextMenu
                                                                                                              showEvent="dxclick"
                                                                                                              dataSource={[
                                                                                                                {
                                                                                                                  text: "Edit Offense",
                                                                                                                  icon: "edit",
                                                                                                                },
                                                                                                              ]}
                                                                                                              target={`#${uniqueId}`}
                                                                                                              onItemClick={(
                                                                                                                e,
                                                                                                              ) => {
                                                                                                                if (
                                                                                                                  e
                                                                                                                    .itemData
                                                                                                                    .text ===
                                                                                                                  "Edit Offense"
                                                                                                                ) {
                                                                                                                  setEditOffenseMode(
                                                                                                                    "EDIT",
                                                                                                                  );
                                                                                                                  setOffensePopupOpen(
                                                                                                                    true,
                                                                                                                  );
                                                                                                                  setOffenseRowData(
                                                                                                                    rowData
                                                                                                                      .data
                                                                                                                      .obj,
                                                                                                                  );
                                                                                                                }
                                                                                                              }}
                                                                                                            />
                                                                                                          </div>
                                                                                                        </>
                                                                                                      );
                                                                                                    }
                                                                                                  : val?.moreoption &&
                                                                                                      obligationfeeListMenu
                                                                                                    ? (rowData) => {
                                                                                                        return (
                                                                                                          <>
                                                                                                            <div
                                                                                                              className="add_navBar_hamburger"
                                                                                                              id="threedotsarrearage"
                                                                                                              onClick={() => {
                                                                                                                setobligationFeeListRowData(
                                                                                                                  rowData.data,
                                                                                                                );
                                                                                                              }}
                                                                                                            >
                                                                                                              <ThreeDotMenu />
                                                                                                              <ContextMenu
                                                                                                                showEvent="dxclick"
                                                                                                                dataSource={[
                                                                                                                  {
                                                                                                                    text: "Jump to Fee",
                                                                                                                    icon: "search",
                                                                                                                  },
                                                                                                                ]}
                                                                                                                target="#threedotsarrearage"
                                                                                                                onItemClick={(
                                                                                                                  e,
                                                                                                                ) => {
                                                                                                                  if (
                                                                                                                    e
                                                                                                                      .itemData
                                                                                                                      .text ===
                                                                                                                    "Jump to Fee"
                                                                                                                  ) {
                                                                                                                    dispatch(
                                                                                                                      removeDynamicTab(
                                                                                                                        `/administration/users/obligationfee`,
                                                                                                                      ),
                                                                                                                    );
                                                                                                                    dispatch(
                                                                                                                      setDynamicTab(
                                                                                                                        {
                                                                                                                          link: `/administration/users/obligationfee`,
                                                                                                                          title:
                                                                                                                            "Obligation Fee",
                                                                                                                          Offender:
                                                                                                                            obligationFeeListRowData,
                                                                                                                        },
                                                                                                                      ),
                                                                                                                    );
                                                                                                                    navigate(
                                                                                                                      `/administration/users/obligationfee`,
                                                                                                                    );
                                                                                                                  }
                                                                                                                }}
                                                                                                              />
                                                                                                            </div>
                                                                                                          </>
                                                                                                        );
                                                                                                      }
                                                                                                    : ""
                    }
                  />
                );
              }
            })}
          {/* <Pager
            showPageSizeSelector={true}
            allowedPageSizes={[10, 20, 30, 50]}
            showNavigationButtons={true}
            showInfo={true}
            visible={true}
          />
          <Paging defaultPageSize={pageSize || 50} /> */}
          {serverPaging ? (
            <>
              <Paging enabled={serverPaging} pageSize={pageSize} />
              <Pager
                visible={serverPaging}
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 30, 50]}
                showNavigationButtons={true}
                showInfo={true}
              />
            </>
          ) : (
            <>
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 30, 50]}
                showNavigationButtons={true}
                showInfo={true}
                visible={true}
              />
              {/* <Paging defaultPageSize={50} /> */}
            </>
          )}
        </DataGrid>

        {Contextmenu && (
          <ContextMenu
            dataSource={
              Attendance
                ? [
                    { text: "Remove Attendance Status", icon: "trash" },
                    {
                      text: "Void Appointment",
                      icon: "remove",
                      disabled: desableReportData,
                    },
                    {
                      text: "Print Next Report Date",
                    },
                  ]
                : [
                    {
                      text: "Enter Attendance",
                      icon: "event",
                    },
                    { text: "Remove Attendance Status", icon: "trash" },
                    {
                      text: "Void Appointment",
                      icon: "remove",
                      disabled: desableReportData,
                    },
                    {
                      text: "Print Next Report Date",
                    },
                  ]
            }
            target=".dx-data-row"
            onItemClick={async (e) => {
              if (e.itemData.text === "Enter Attendance") {
                if (enableReportDateTabs) {
                  dispatch(
                    setDynamicTab({
                      link: `/enterattendence/${selectedRow?.val?.gPersonId}`,
                      title: `Report Dates ${selectedRow?.val?.sLastFirst?.split(",")[0]}`,
                    }),
                  );
                  dispatch(
                    set_user_data({
                      personId: selectedRow?.val?.gPersonId,
                      preReportNote: selectedRow?.val?.sPreReportNote,
                      gReportDateScheduleId: selectedRow?.val?.gReportDateScheduleId,
                      sentanceNote: sentanceNote,
                      sOffenderNumber: selectedRow?.val?.sOffenderNumber,
                    }),
                  );
                  navigate(`/enterattendence/${selectedRow?.val?.gPersonId}`);
                } else {
                  setenterAttendencePopup(true);
                }
              } else if (e.itemData.text === "Void Appointment") {
                setvoidPopup(true);
              } else if (e.itemData.text === "Remove Attendance Status") {
                setremoveAttendenceStatus(!removeAttendenceStatus);
              } else if (e.itemData.text === "Print Next Report Date") {
                setLoading(true);
                await axios
                  .get(
                    `${process.env.REACT_APP_CRYSTAL_API_URL}/reports-api/reports/get-print-nrd?sOffenderNumber=${selectedRow.sOffenderNumber}&sActivityId=${selectedRow.gPreReportActivityNoteId}`,
                    {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        Domain: `${pathname}`,
                      },
                      responseType: "blob",
                    },
                  )
                  .then((val) => {
                    setLoading(false);
                    if (val?.data?.size > 20) {
                      const pdfBlob = new Blob([val.data], {
                        type: "application/pdf",
                      });
                      const pdfUrl = URL.createObjectURL(pdfBlob);
                      const downloadLink = document.createElement("a");
                      downloadLink.href = pdfUrl;
                      downloadLink.download = "Report_Date" + ".pdf";
                      downloadLink.style.display = "none";
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                      document.body.removeChild(downloadLink);
                    }
                  })
                  .catch((val) => {
                    setLoading(false);
                  });
              }
            }}
          />
        )}
        {attachmentRightCickPopup && (
          <ContextMenu
            dataSource={[
              { text: "Email Attachment", icon: "email" },
              { text: "Delete", icon: "remove" },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Delete") {
                if (attachmentRightCickPopup) {
                  console.log("right click");
                  setattachmentdeletePopup(true);
                }
              }
            }}
          />
        )}
        {DocketObligationTableRightClick && (
          <ContextMenu
            dataSource={[
              {
                text: "Generate Payment Plan",
                disabled: desableGeneratePaymetPLan,
              },
              { text: "Write Off Amount", disabled: desablewriteoff },
              { text: "Go To Obligation" },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Generate Payment Plan") {
                if (setopenGeneratePaymentPlanpopup) {
                  setopenGeneratePaymentPlanpopup(true);
                }
              } else if (e.itemData.text === "Write Off Amount") {
                if (setWrieOffpopup) {
                  setWrieOffpopup(true);
                }
              } else if (e.itemData.text === "Go To Obligation") {
                if (!selectedRow) {
                  return;
                }
                dispatch(setAddObligation(false));
                localStorage.setItem("RedirecttoObligation", selectedRow?.gObligationId);
                dispatch(
                  setDynamicTab({
                    Offender: `/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`,
                    link: `/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`,
                    title: `Obligation : ${selectedRow?.sDocketNumberCourtCounts} / ${selectedRow?.["Obligation Ref#"]}`,
                    sDocketNumberCourtCounts: selectedRow?.sDocketNumberCourtCounts,
                    ObligationRef: selectedRow?.["Obligation Ref#"],
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: selectedRow?.userinfo,
                  }),
                );
                dispatch(
                  setgotooblogationValue({
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: selectedRow?.userinfo,
                    docketRef: dockerHeaderData?.sReference,
                  }),
                );
                navigate(`/obligation/${selectedRow?.gObligationId}/${selectedRow?.["Obligation Ref#"]}`);
              }
            }}
          />
        )}
        {Revocationscontextmenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Revocation",
                icon: "edit",
              },
              {
                text: "Void Revocation",
                icon: "remove",
                disabled: desableRevocation,
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Revocation") {
                if (seteditRevocationspopup) {
                  seteditRevocationspopup(true);
                }
              } else if (e.itemData.text === "Void Revocation") {
                setVoidPopup(true);
              }
            }}
          />
        )}
        {EMPeriodcontextmenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Add EM Period",
                icon: "add",
              },
              {
                text: "Edit EM Period",
                icon: "edit",
              },
              {
                text: "Void EM Period",
                icon: "remove",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Add EM Period") {
                setEMPriodpopshow(true);
              } else if (e.itemData.text === "Edit EM Period") {
                setEMPriodeditpopshow(true);
              } else if (e.itemData.text === "Void EM Period") {
                setEMPeriodConfirmPopup(true);
              }
            }}
          />
        )}

        {taskcontextmenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Task",
                icon: "edit",
              },
              {
                text: "Pending/Delay 30 Days",
                icon: "clock",
              },
              {
                text: "Complete Task",
                icon: "check",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Task") {
                if (setAddQuickPopup) {
                  setAddQuickPopup(true);
                  setresettask(!resettask);
                }
              } else if (e.itemData.text === "Pending/Delay 30 Days") {
                setPendingPOpuptogal(true);
                setresettask(!resettask);
              } else if (e.itemData.text === "Complete Task") {
                getCompletTask(false);
              }
            }}
          />
        )}
        {editInvoiceTable && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Item",
                icon: "edit",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Item") {
                setSelectedItem(selectedItem);
                setEditItemPopup(true);
              }
            }}
          />
        )}
        {taskcontextmenu2 && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Task",
                icon: "edit",
              },
              {
                text: "Add Task",
                icon: "add",
              },
              {
                text: "Jump to Person",
                icon: "search",
              },
              {
                text: "Pending/Delay 30 Days",
                icon: "clock",
              },
              {
                text: "Reassign Selected Tasks",
                icon: "add",
              },
              {
                text: "Task Completed",
                icon: "check",
              },
              {
                text: "Approve/Process Close-out",
                disabled: selectedRow?.categoryId?.toLowerCase() !== "60dded19-3eea-4af8-bc1a-9a37ae4fe85a",
              },
              {
                text: "Approve/Process Allocation Adjustment",
                disabled: false,
              },
              {
                text: "Approve/Process Refund",
                // disabled: !(selectedRow?.categoryId === "A62E2033-D400-4FDB-A4AC-7C78C8813FD4".toLowerCase())
                disabled: !(gUserId?.toLowerCase() === selectedRow?.assignedToId?.toLowerCase()),
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Task") {
                setAddQuickPopup(true);
                setresettask(!resettask);
              } else if (e.itemData.text === "Add Task") {
                setAddQuickPopup(true);
                setAddTaskPopupType("Add");
              } else if (e.itemData.text === "Pending/Delay 30 Days") {
                setPendingPOpuptogal(true);
                setresettask(!resettask);
              } else if (e.itemData.text === "Task Completed") {
                getCompletTask(selectedRow?.taskId);
              } else if (e.itemData.text === "Approve/Process Close-out") {
                const taskId = selectedRow?.taskId;

                if (!taskId) {
                  return;
                }

                dispatch(
                  setDynamicTab({
                    link: `/process-person-closeout/${taskId}`,
                    title: "Process Person Closeout",
                  }),
                );

                navigate(`/process-person-closeout/${taskId}`);
              } else if (e.itemData.text === "Approve/Process Allocation Adjustment") {
                const taskId = selectedRow?.taskId;
                const userId = localStorage.getItem("gUserId");

                if (taskId && userId) {
                  AllocationAdjustment(taskId, userId);
                } else {
                  console.error("Task ID or User ID is missing.");
                }
              } else if (e.itemData.text === "Reassign Selected Tasks") {
                setReassignTasksPopup(true);
              } else if (e.itemData.text === "Jump to Person") {
                if (!selectedRow?.offenderNumber) {
                  return;
                }

                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow.offenderNumber}`,
                    Offender: selectedRow.offenderNumber,
                    title: selectedRow?.name?.split(",")[0],
                  }),
                );

                navigate(`/participant/${selectedRow.offenderNumber}`);
              } else if (e.itemData.text === "Approve/Process Refund") {
                approveRefund();
              }
            }}
          />
        )}
        {CheckListTableRightClick && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Note",
                icon: "edit",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Note") {
                if (CheckListTableRightClick) {
                  setresetCHecklist(!CHecklistreset);
                  seteditCHeckoutNotePOpup(true);
                }
              }
            }}
          />
        )}
        {editCheclListOptionrightClist && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit",
                icon: "edit",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit") {
                if (editCheclListOptionrightClist) {
                  editchecklistoptionsetpopup(true);
                }
              }
            }}
          />
        )}
        {GoToChildDocketrightClick && (
          <ContextMenu
            dataSource={[
              {
                text: "Go To Docket",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Go To Docket") {
                if (!selectedRow) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${selectedRow?.["Docket #"]}`,
                    sDocketNumberCourtCounts: selectedRow?.["Docket #"],
                    userinfo: selectedRow?.userinfo,
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                    userinfo: selectedRow?.userinfo,
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
              }
            }}
          />
        )}
        {REportWizardActiveLIst && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Source",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Source") {
                if (!selectedRow || !selectedRow?.["Offender #"]) {
                  return;
                }
                if (selectedRow?.Source === "Person") {
                  dispatch(
                    setDynamicTab({
                      link: `/participant/${selectedRow?.["Offender #"]}`,
                      Offender: selectedRow?.["Offender #"],
                      title: selectedRow?.["Offender Name"]?.split(",")[0],
                    }),
                  );
                  navigate(`/participant/${selectedRow?.["Offender #"]}`);
                }
              }
            }}
          />
        )}
        {REportWizardPaymentlist && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Obligation",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender No"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender No"]}`,
                    Offender: selectedRow?.["Offender No"],
                    title: selectedRow?.["Person Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender No"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketID}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketID}`,
                    title: `Docket ${`${"tempdata2"} - ${"tempdata2"}`}`,
                    sDocketNumberCourtCounts: `${"tempdata2"} - ${"tempdata2"}`,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketID}`);
              } else if (e.itemData.text === "Jump To Obligation") {
                dispatch(
                  setDynamicTab({
                    Offender: `/obligation/${selectedRow?.gObligationID}/${"tempdata"}`,
                    link: `/obligation/${selectedRow?.gObligationID}/${"tempdata"}`,
                    title: `Obligation : ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`} / ${"tempdata"}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    ObligationRef: "tempdata",
                    gObligationId: selectedRow?.gObligationID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                dispatch(
                  setgotooblogationValue({
                    gObligationId: selectedRow?.gObligationID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/obligation/${selectedRow?.gObligationID}/${"tempdata"}`);
              }
            }}
          />
        )}
        {ReportWizardDocketLIstrightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender"]}`,
                    Offender: selectedRow?.["Offender"],
                    title: selectedRow?.["Offender Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow || selectedRow?.userinfo?.gPersonId == null) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    userinfo: selectedRow?.userinfo,
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                    userinfo: selectedRow?.userinfo,
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
              }
            }}
          />
        )}
        {ActivePersonListrightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender Number"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender Number"]}`,
                    Offender: selectedRow?.["Offender Number"],
                    title: selectedRow?.["Last Name"],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender Number"]}`);
              }
            }}
          />
        )}
        {ReportDaterightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender #"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender #"]}`,
                    Offender: selectedRow?.["Offender #"],
                    title: selectedRow?.["Offender Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender #"]}`);
              }
            }}
          />
        )}
        {Disbursementrightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Obligation",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender #"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender #"]}`,
                    Offender: selectedRow?.["Offender #"],
                    title: selectedRow?.["Offender Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender #"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow || selectedRow?.userinfo?.gPersonId == null) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
              } else if (e.itemData.text === "Jump To Obligation") {
                dispatch(
                  setDynamicTab({
                    Offender: `/obligation/${selectedRow?.gObligationId}/${"tempdata"}`,
                    link: `/obligation/${selectedRow?.gObligationId}/${"tempdata"}`,
                    title: `Obligation : ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`} / ${"tempdata"}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    ObligationRef: "tempdata",
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                dispatch(
                  setgotooblogationValue({
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                navigate(`/obligation/${selectedRow?.gObligationId}/${"tempdata"}`);
              }
            }}
          />
        )}
        {DrugTestREportWizardrightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender #"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender #"]}`,
                    Offender: selectedRow?.["Offender #"],
                    title: selectedRow?.["Offender Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender #"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow || selectedRow?.userinfo?.gPersonId == null) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${selectedRow?.["sDocketNumberCourtCounts"]}`,
                    sDocketNumberCourtCounts: selectedRow?.["sDocketNumberCourtCounts"],
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
              }
            }}
          />
        )}
        {ObligationLIstrightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Obligation",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender"]}`,
                    Offender: selectedRow?.["Offender"],
                    title: selectedRow?.["Offender Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow || selectedRow?.userinfo?.gPersonID == null) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
                dispatch(
                  setDynamicTab({
                    Offender: `/obligation/${selectedRow?.gObligationId}/${"tempdata"}`,
                    link: `/obligation/${selectedRow?.gObligationId}/${"tempdata"}`,
                    title: `Obligation : ${`${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`} / ${"tempdata"}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sDocketNumber"]} - ${selectedRow?.["iCourtCounts"]}`,
                    ObligationRef: "tempdata",
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                dispatch(
                  setgotooblogationValue({
                    gObligationId: selectedRow?.gObligationId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                navigate(`/obligation/${selectedRow?.gObligationId}/${"tempdata"}`);
              }
            }}
          />
        )}
        {PreDisbursementsReporteightclick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Jump To Obligation",
                icon: "search",
              },
              {
                text: "Jump To Docket",
                icon: "search",
              },
              // {
              //   text: "Select All",
              // },
              // {
              //   text: "Select None",
              // },
              // {
              //   text: "Print Checks",
              // },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (!selectedRow || !selectedRow?.["Offender #"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Offender #"]}`,
                    Offender: selectedRow?.["Offender #"],
                    title: selectedRow?.["Person Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Offender #"]}`);
              } else if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow || selectedRow?.userinfo?.gPersonID == null) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketID}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketID}`,
                    title: `Docket ${`${"tempdata2"} - ${"tempdata2"}`}`,
                    sDocketNumberCourtCounts: `${"tempdata2"} - ${"tempdata2"}`,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketID}`);
              } else if (e.itemData.text === "Jump To Obligation") {
                dispatch(
                  setDynamicTab({
                    Offender: `/obligation/${selectedRow?.gObligationID}/${"tempdata"}`,
                    link: `/obligation/${selectedRow?.gObligationID}/${"tempdata"}`,
                    title: `Obligation : ${`${selectedRow?.["sReference"]} - ${selectedRow?.["sReference"]}`} / ${"tempdata"}`,
                    sDocketNumberCourtCounts: `${selectedRow?.["sReference"]} - ${selectedRow?.["sReference"]}`,
                    ObligationRef: "tempdata",
                    gObligationId: selectedRow?.gObligationID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                dispatch(
                  setgotooblogationValue({
                    gObligationId: selectedRow?.gObligationID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/obligation/${selectedRow?.gObligationID}/${"tempdata"}`);
              } else if (e.itemData.text === "Select All") {
                setselectAll(true);
              } else if (e.itemData.text === "Select None") {
                setPreDisbursementsReportcheckbox([]);
                setselectAll(false);
              } else if (e.itemData.text === "Print Checks") {
                setPrintCheckPopup(true);
              }
            }}
          />
        )}
        {DocketManagementRightClick && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Docket",
                icon: "search",
              },
              // {
              //   text: "Quick Add Obligation",
              //   disabled: false,
              // },
              {
                text: "Change Supervision Status",
                disabled: !selectedRowCheckbox.length,
              },
              {
                text: "Change Finacial Status",
                disabled: !selectedRowCheckbox.length,
              },
              {
                text: "Change Supervisor",
                disabled: !selectedRowCheckbox.length,
              },
              {
                text: `Add Revocation(${selectedRowCheckbox?.length || 0})`,
                // disabled: true,
              },
              // {
              //   text: "Add Revocation(s)",
              //   disabled: true,
              // },
              { text: `Add Warrants (${selectedRowCheckbox?.length || 0})` },
              {
                text: "Add Tolling",
                disabled: !selectedRowCheckbox.length,
              },
              {
                text: "Move Obligation to Another Docket ",
                disabled: true,
              },
              {
                text: "Delete Docket",
                disabled: true,
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Docket") {
                if (!selectedRow?.userinfo?.gDocketId && !selectedRow?.userinfo?.gPersonId) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    link: `/docket/${selectedRow?.userinfo?.gDocketId}`,
                    title: `Docket ${`${selectedRow?.sDocketNumberCourtCounts}`}`,
                    sDocketNumberCourtCounts: `${selectedRow?.sDocketNumberCourtCounts}`,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.userinfo?.gDocketId,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonId,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.userinfo?.gDocketId}`);
              }

              // if (e.itemData.text === "Quick Add Obligation") {
              //   setHeader({
              //     ...header,
              //     sDocketNumberCourtCounts: selectedRow["Docket/Count"],
              //   });
              //   setDocketId(selectedRow?.userinfo?.gDocketId);
              //   dispatch(setRecentDocket(selectedRow?.data));
              //   setgetQuickaddObligationPopup(true);
              // }

              if (e.itemData.text === "Change Supervision Status") {
                setChangesuperviserDatePOpup(true);
              }

              if (e.itemData.text === "Change Finacial Status") {
                setChangeFinancialStatusPopup(true);
              }

              if (e.itemData.text === "Change Supervisor") {
                setChangeSupervisorPopup(true);
              }
              if (e.itemData.text === `Add Revocation(${selectedRowCheckbox?.length || 0})`) {
                setAddRevocationspopup(true);
              }
              if (e.itemData.text === `Add Warrants (${selectedRowCheckbox?.length || 0})`) {
                setAddWarrentsPopup(true);
              }
              if (e.itemData.text === "Add Tolling") {
                setAddTollingPopup(true);
              }
            }}
          />
        )}
        {arrearageMinderMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump to Person",
                icon: "search",
              },
              {
                text: "Send Arrearage Notification",
                icon: "email",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump to Person") {
                if (!selectedRow || !selectedRow?.["Client Id"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Client Id"]}`,
                    Offender: selectedRow?.["Client Id"],
                    title: selectedRow?.["Client Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Client Id"]}`);
              } else if (e.itemData.text === "Send Arrearage Notification") {
                setSendEmailPopup(true);
              }
            }}
          />
        )}
        {obligationfeeListMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump to Fee",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump to Fee") {
                dispatch(removeDynamicTab(`/administration/users/obligationfee`));
                dispatch(
                  setDynamicTab({
                    link: `/administration/users/obligationfee`,
                    title: "Obligation Fee",
                    Offender: selectedRow,
                  }),
                );
                navigate(`/administration/users/obligationfee`);
              }
            }}
          />
        )}
        {conditionVerbiageMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Verbiage",
                icon: "edit",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Verbiage") {
                setEditVerbiageMode("EDIT");
                setEditVerbiagePopupOpen(true);
              }
            }}
          />
        )}
        {OffensesMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Edit Offense",
                icon: "edit",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Edit Offense") {
                setEditOffenseMode("EDIT");
                setOffensePopupOpen(true);
              }
            }}
          />
        )}
        {revenueReportMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump to Person",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump to Person") {
                if (!selectedRow || !selectedRow?.["Client Id"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Client Id"]}`,
                    Offender: selectedRow?.["Client Id"],
                    title: selectedRow?.["Client Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Client Id"]}`);
              }
            }}
          />
        )}
        {agingReportMenu && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump to Person",
                icon: "search",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump to Person") {
                if (!selectedRow || !selectedRow?.["Client Id"]) {
                  return;
                }
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow?.["Client Id"]}`,
                    Offender: selectedRow?.["Client Id"],
                    title: selectedRow?.["Client Name"]?.split(",")[0],
                  }),
                );
                navigate(`/participant/${selectedRow?.["Client Id"]}`);
              }
            }}
          />
        )}
        {personListControl && (
          <ContextMenu
            target=".dx-data-row"
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
              {
                text: "Send Email",
                icon: "email",
              },
              {
                text: "Merge person",
              },
            ]}
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                if (selectedRow?.gMergePersonID) {
                  setMergedPerson(selectedRow?.gMergePersonID);
                  setConfirmPopup(true);
                } else {
                  if (selectedRow.personlistfullName) {
                    saveCookieCrum(selectedRow.gPersonID);
                    dispatch(
                      setDynamicTab({
                        link: `/participant/${selectedRow["Offender #"]}`,
                        Offender: selectedRow["Offender #"],
                        title: selectedRow.personlistfullName,
                      }),
                    );
                  } else {
                    saveCookieCrum(selectedRow.gPersonId);
                    dispatch(
                      setDynamicTab({
                        link: `/participant/${selectedRow["Offender #"]}`,
                        Offender: selectedRow["Offender #"],
                        title: selectedRow?.sLastName,
                      }),
                    );
                  }

                  navigate(`/participant/${selectedRow["Offender #"]}`);
                }
              }

              if (e.itemData.text === "Send Email") {
                showSendEmailPopup();
              }
              if (e.itemData.text === "Merge person") {
                setPerson(selectedRow?.gPersonID);
                setLast(`${selectedRow["Last Name"]}, ${selectedRow["First Name"]}`);
                setSourcePersonId(selectedRow["Offender #"]);
                setMergedPerson(selectedRow?.gMergePersonID);
                if (selectedRow?.gMergePersonID) {
                  setConfirmPopup(true);
                } else {
                  setIsMergePopupVisible(true);
                }
              }
            }}
          />
        )}
        {periodSummaryControl && (
          <ContextMenu
            target=".dx-data-row"
            dataSource={[
              {
                text: "Jump To Person",
                icon: "search",
              },
            ]}
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Person") {
                saveCookieCrum(selectedRow["Offender Name"]);
                dispatch(
                  setDynamicTab({
                    link: `/participant/${selectedRow["Offender #"]}`,
                    Offender: selectedRow["Offender #"],
                    title: selectedRow["Offender Name"].slice(0, selectedRow["Offender Name"].indexOf(",")),
                  }),
                );
                navigate(`/participant/${selectedRow["Offender #"]}`);
              }
            }}
          />
        )}
        {docketListControl && (
          <ContextMenu
            dataSource={[
              {
                text: "Jump To Docket",
                icon: "search",
              },
              {
                text: "Send Email",
                icon: "email",
              },
              {
                text: "Change Supervisor",
              },
            ]}
            target=".dx-data-row"
            onItemClick={(e) => {
              if (e.itemData.text === "Jump To Docket") {
                dispatch(
                  setDynamicTab({
                    Offender: `/docket/${selectedRow?.gDocketID}`,
                    link: `/docket/${selectedRow?.gDocketID}`,
                    title: `Docket ${selectedRow?.sDocketNumberCourtCounts}`,
                    sDocketNumberCourtCounts: selectedRow?.sDocketNumberCourtCounts,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                    getTopDynamicDocketid: selectedRow?.gDocketID,
                  }),
                );
                dispatch(
                  setdockerValue({
                    getTopDynamicDocketid: selectedRow?.gDocketID,
                    userinfo: {
                      ...selectedRow?.userinfo,
                      gPersonId: selectedRow?.userinfo?.gPersonID,
                    },
                  }),
                );
                navigate(`/docket/${selectedRow?.gDocketID}`);
              }

              if (e.itemData.text === "Send Email") {
                showSendEmailPopup();
                setSendEmail(true);
              }
              if (e.itemData.text === "Change Supervisor") {
                if (!selectedPersonIds.length) {
                  showSendEmailPopup();
                  return;
                } else {
                  setSupervisorChangePopup(true);
                }
              }
            }}
          />
        )}
        <p
          style={{
            color: "var(--TextColor)",
            fontWeight: 800,
            marginTop: "10px",
            //float: "left",
          }}
        >
          Count: {count}
        </p>
      </div>
    );
  },
);
